<template>
  <section class="bank-agreement-container">
    <p class="title">统统付银行卡支付服务协议</p>
    <p>
      统统付银行卡支付服务协议（以下简称“本协议”）是商盟商务服务有限公司（以下简称“商盟”或“统统付”）与用户(以下简称“用户”或“您”)就银行卡（借记卡/信用卡）支付服务（以下简称“本服务”）的使用等相关事宜所订立的有效协议。您通过网络页面或手机客户端界面等点击或以其他方式同意/确认/接受本协议，即表示您与商盟已达成协议并同意接受本协议的全部内容。
    </p>
    <p>
      在接受本协议之前，请您仔细阅读本协议的全部内容<strong class="under-line"
        >（特别是以粗体下划线标注的内容）</strong
      >。如果您不同意本协议的任意内容，或者无法准确理解商盟对条款的解释，请不要进行后续操作。
    </p>
    <p>
      <strong class="under-line"
        >您应确保您具有完全民事权利能力和民事行为能力，您在使用本服务时的银行卡为您本人的银行卡，确保您使用银行卡的行为合法、有效且未侵犯任何第三方合法权益，否则因此造成商盟、银行卡所有人损失的，您应负责赔偿并承担全部法律责任，包括但不限于赔偿损失、临时锁定交易资金等。</strong
      >
    </p>
    <p>
      您同意并申请使用实名认证、银行卡实名验证服务，您授权商盟对商盟收集或由商户收集并转交商盟的您在使用本服务过程中所填写的姓名、身份证号、手机号码、银行卡信息等必要的个人信息转交给中国银联（适用于通过中国银联处理的交易，下同）/中国网联（适用于通过中国网联处理的交易，下同）提交发卡机构用于持卡人身份匹配性核验，发卡机构将上述个人信息用于一致性比对后，通过中国银联/中国网联、商盟返回核验结果；并同意将该银行卡与您此次在商户网站登录的用户进行绑定，以便您此次及今后进行支付。您可以通过商盟、中国银联/中国网联和发卡机构的官网、APP各自展示的个人隐私政策进一步了解其联系方式、个人信息的保存期限和用户行使个人信息权益的方式和程序等个人信息处理相关的内容。在商盟收集您的个人信息的情形下，商盟将严格按照《中华人民共和国个人信息保护法》等相关法律法规的要求，依法收集、使用和对外提供您的个人信息，并依法承担相关责任，详情请参阅《统统付隐私权政策》；在商户收集您的个人信息的情况下，商盟已要求商户严格履行《中华人民共和国个人信息保护法》等相关法律法规的义务，确保其提供给商盟的个人信息来源合法合规，详情请查阅商户的个人信息保护政策。
    </p>
    <p>
      为满足反洗钱等监管要求，您授权商盟有权留存您填写的信息以及快捷支付服务的交易信息。
    </p>
    <p>
      您须妥善保管您的密码、数字证书、银行卡账户、卡号、有效期、CVV2/CVC2、证件号码、手机验证码等一切敏感信息，不得将敏感信息向他人泄露。如您遗失银行卡、泄露账户密码或相关信息的，您应及时通知发卡行及/或商盟，以减少可能发生的损失。<strong
        class="under-line"
        >因您对密码、银行卡、数字证书、手机等保管不善产生的风险及损失由您本人承担。因泄露敏感信息或丢失银行卡/手机等所导致的损失须由您自行承担。</strong
      >
    </p>
    <p>
      您应确保开通本服务所提供的手机号码为您本人所有。您保证将妥善保管您与使用的银行卡（借记卡/信用卡）绑定的手机号码，并且同意商盟有权将该手机号码发送的信息作为您的账户、密码和/或数字证书等方式之外的识别您的身份及支付指令的其它方式。<strong
        class="under-line"
        >所有使用该手机号码所发送的操作指令均可视为您的授权操作行为，因此而产生的责任均由您承担。因手机或手机号码遗失、泄露、失窃等任一原因所导致的损失均由您自行承担。</strong
      >
    </p>
    <p>
      <strong class="under-line"
        >任何使用与您使用的银行卡（借记卡/信用卡）绑定的手机号码所发送至商盟计算机系统的支付指令，应被视为经您授权的不可撤销的付款指示，商盟对于计算机系统按照收到的符合约定的支付指令完成支付的行为不承担任何责任。</strong
      >
    </p>
    <p>
      商盟及您所持银行卡发卡行仅提供您与商家在购买交易过程中的相关款项的支付结算服务，因商家的商品或服务所产生的有关商品或服务本身的产品质量、服务质量、费用金额等争议均由您与提供商品或服务的商家自行协商解决，概与商盟及发卡行无关。
    </p>
    <p>
      您不应将本服务用于任何非法的或违反本协议的目的。您应保证您在使用本服务时是合法、有效的，且您应保证将本服务用于合法或本协议约定的目的。您保证对您使用本服务所发出的指令的真实性和有效性负责。若您违反前述保证从而给商盟、发卡行或银行卡所有人造成损失的，您应负责赔偿并承担全部法律责任。您授权商盟可向您的开户行发送支付指令，扣划您银行账户资金。<strong
        class="under-line"
        >您认可和同意：输入密码或短信验证码即视为您确认交易和交易金额并已不可撤销地向商盟发出指令，商盟有权根据您的指令委托银行或第三方从银行卡中扣划资金给收款人。届时您不应以非本人意愿交易或其他任何原因要求商盟退款或承担其他责任。</strong
      >您在对使用本服务过程中发出指令的真实性及有效性承担全部责任。您承诺，商盟依照您的指令进行操作的一切风险由您承担。<strong
        class="under-line"
        >您认可您的使用记录数据、交易金额数据等均以商盟交易系统平台记录的数据为准。</strong
      >
    </p>
    <p>
      您同意并授权商盟依据其自身判断对涉嫌欺诈或被他人控制并用于欺诈等非法目的的资金采取相应的措施，上述措施包括但不限于临时锁定资金、处置涉嫌欺诈的资金等。<strong
        class="under-line"
        >您存在下列情形之一的，商盟有权立即终止您使用相关服务而无需承担任何责任：①您违反法律法规政策等规定的；②您违反本协议约定的；③您违反商盟或其他关联公司发布的使用本服务所必须遵守的协议、条款、规则、通告等相关规定的；④商盟认为向您提供本服务存在风险的。⑤您的银行卡有效期届满（如有）。</strong
      >
    </p>
    <p>
      商盟有权向您收取使用本服务的服务费。收费方式及收费标准以商盟通过页面展示、手机应用、网站、其他电子渠道等适当方式公告的内容为准。
    </p>
    <p>
      您同意，本协议适用中华人民共和国大陆地区法律。就本协议所引起的任何争议和纠纷，均应由双方友好协商解决；如协商不成的，您和商盟均有权向商盟住所地人民法院提起诉讼。
    </p>
    <p>
      所有使用本服务而必须遵守的商盟已发布或将来可能发布的协议、附件和规则等均构成本协议不可分割的组成部分，与本协议具有同等法律效力。您同意，商盟有权对本协议内容进行相应修改或变更，并通过在商盟官方网站公布的形式进行通知，修改或变更后的协议内容在商盟官方网站公布即有效代替原来的协议，您须定期关注、注意商盟官方网站并定期审阅本协议及其变更内容。若您不同意商盟对本协议所作的任何修改或变更，您应立即停止使用本服务。若您在本协议内容公布变更后仍继续使用本服务，则表示您已充分阅读、理解、同意并接受修改或变更后的协议内容，也将遵循修改或变更后的协议内容使用本服务。
    </p>
    <p>
      本协议未尽事宜，您需遵守商盟官方网站上公布的《统统付服务协议》及相关规则。
    </p>
    <p>
      <strong
        >若您为华夏银行持卡人，使用华夏银行银行卡（借记卡/信用卡）进行协议支付，您还同意与华夏银行股份有限公司签订《华夏银行个人客户“网联协议支付”服务协议》，并通过网络页面或手机客户端界面等点击或以其他方式同意/确认/接受《华夏银行个人客户“网联协议支付”服务协议》的全部内容。</strong
      >
    </p>
    <section class="common-cnt">
      <p class="sub-title">华夏银行个人客户“网联协议支付”服务协议</p>
      <p>甲方：华夏银行持卡人</p>
      <p>乙方：华夏银行股份有限公司</p>
      <p style="text-align: center; font-weight: bold; margin: 15px 0;">
        风险提示
      </p>
      <p>
        为确保甲方安全使用乙方网联协议支付服务，保护账户资金安全，请甲方务必注意以下几点：
      </p>
      <p>
        <strong
          >1、选择专用于协议支付的华夏卡。为保障甲方的资金安全，建议甲方选择资金余额相对较少的华夏卡专门用于协议支付服务，不要将所有华夏卡均签约协议支付业务。</strong
        >
      </p>
      <p>
        <strong
          >2、甲方签约协议支付的华夏卡需在我行开通账务短信通知服务，方可成功签约。请在签约协议支付业务前，确保签约的华夏卡已开通了账务短信通知功能，以便甲方的华夏卡发生资金变化时，可随时了解并查询。请甲方更换手机号码后，及时到乙方营业机构更新甲方的账务短信通知手机号码，并立即解约协议支付业务，然后使用更换后的手机号码在第三方支付机构重新进行协议支付业务签约。</strong
        >
      </p>
      <p>
        <strong
          >3、能够承受协议支付的相关风险。由于本业务需要在事先或者首次支付时进行签约，签约时第三方支付机构需要采集甲方的姓名、卡号、证件号码、签约账务短信通知的手机号码等信息，这些信息可能存在被泄露、导致资金损失的风险；甲方在签约完成进行支付时，仅使用用户协议号进行支付，可能导致由于协议号泄露等，被他人盗用发生资金损失的风险。</strong
        >
      </p>
      <p>
        为明确甲、乙双方的权利和义务，规范双方业务行为，根据《中华人民共和国合同法》、《中华人民共和国电子签名法》、《中华人民共和国反洗钱法》等法律以及网联清算有限公司相关业务规范，本着平等互利的原则，经甲、乙双方协商一致，就借记卡/信用卡网联协议支付服务（以下简称“本服务”）的使用等相关事项达成本协议（以下简称“本协议”），双方保证遵守以下条款。甲方通过互联网（Internet）点击确认或以其他方式选择接受本协议，即表示甲方同意接受本协议的全部约定内容，确认承担由此产生的责任。
      </p>
      <p>
        一、在接受本协议之前，请甲方仔细阅读本协议的全部内容（特别是以<strong
          class="under-line"
          >粗体下划线</strong
        >标注的内容）。如果甲方不同意本协议的任何内容，或者无法准确理解相关条款的解释，请不要进行后续操作。
      </p>
      <p>
        二、甲方应确保甲方在使用本服务时绑定的借记卡/信用卡为甲方本人所有，并确保甲方将甲方在<strong
          class="under-line"
          >（第三方支付机构名称，以下简称“支付机构”）</strong
        >注册的用户ID与该借记卡/信用卡绑定且用其支付的行为合法、有效，未侵犯任何第三方合法权益；否则因此造成我行、持卡人损失的，甲方应负责赔偿并承担法律责任。
      </p>
      <p>
        <strong class="under-line"
          >三、甲方确认同意我行对由支付机构收集并转交我行的甲方信息（包括在使用本服务过程中所填写的包括但不限于姓名、借记卡/信用卡卡号、签约账务短信通知的手机号码、证件号码等）进行校对核验并生成支付协议号；同意将该借记卡/信用卡在支付机构进行签约绑定，以便甲方此次及今后进行支付。</strong
        >
      </p>
      <p>
        <strong class="under-line"
          >四、一旦上述签约绑定成功，我行为甲方生成支付协议号并将该协议号发送至支付机构，甲方在支付机构发起支付指令后，即视为甲方本人确认支付金额，并同意及授权由支付机构以协议号为支付标识转交我行进行后续处理。甲方同意并授权我行按照支付机构的交易指令从甲方绑定的借记卡/信用卡账户中支付相应款项。</strong
        >
      </p>
      <p>
        五、甲方应妥善保管绑定的该卡开户户名、卡号及相关的证件类型及证件号码、签约账务短信通知的手机号码、固定电话、通信地址等与该卡有关的一切信息（以下简称“身份信息及卡信息”）。如甲方遗失借记卡/信用卡、泄露身份信息及卡信息，甲方应及时挂失并通知我行及支付机构，以减少可能发生的损失。<strong
          class="under-line"
          >因甲方泄露身份信息、卡信息、密码
          ，丢失借记卡/信用卡等原因所致的损失需由甲方承担，我行不承担责任。</strong
        >
      </p>
      <p>
        六、为防范风险，保障甲方的资金安全，我行设置了支付限额。甲方在使用本服务时需受我行设置的支付限额的约束。甲方可以登录我行手机银行/个人网银，或者至我行柜台进行支付限额的修改，修改后的支付限额不能高于我行为该支付机构设定的支付限额。如实际支付金额大于支付限额，我行将拒绝执行交易指令，由此造成的损失由甲方本人承担。
      </p>
      <p>
        七、甲方不得利用协议支付业务进行包括但不限于套现、虚假交易、洗钱、非法集资等非法行为，且甲方有义务配合我行进行相关调查，一旦甲方拒绝配合我行进行相关调查，或我行认为甲方存在或涉嫌套现、虚假交易、洗钱、非法集资等非法行为，或存在欺诈或违反诚信原则的行为，以及违反本协议约定的，我行有权立即采取以下一种、多种或全部措施：（1）暂停或终止提供本协议项下协议支付服务；（2）终止本协议；（3）取消甲方的用卡资格。
      </p>
      <p>
        八、我行有权根据法律、法规、部门规章、监管规定或我行业务发展需要修改支付限额，或变更、暂停本协议项下协议支付业务服务，或修改、变更、终止本协议相关规定，如需甲方确认的，我行通过官方网站或营业网点等渠道进行公告，甲方继续使用协议支付业务的，视为甲方确认。如不需甲方确认的，则自调整或变更之日起对甲方生效。本协议终止后，支付机构在协议终止前已接收并发送至我行的交易指令仍有效，甲方应承担其后果。
      </p>
      <p>
        <strong
          >九、甲方在签约网联协议支付服务时向我行提供的甲方本人及他人有关信息（包括我行不能从公众渠道取得的甲方及他人的个人基本信息、业务相关信息及其他有关信息）真实、准确、有效、完整且已取得他人的同意，我行对甲方提供的信息有保密的义务。我行有权在法律、法规、监管规定、有权机关规定的期限内对甲方提供的信息进行留存并在内部使用（超过上述期限的，我行有权销毁）；有权将甲方提供的信息提供给征信机构或根据法律法规、监管规定、司法机关的强制命令提供甲方提供的信息；有权为履行本协议之目的，将甲方提供的信息披露给我行代理人，并取得代理人的保密承诺。</strong
        >
      </p>
      <p>
        十、甲方如对交易存在疑义，请尽快向乙方提出申明；对于交易订单超过180天的，乙方将不予受理。
      </p>
      <p>
        十一、本协议终止后，支付机构在协议终止前已接收并发送至我行的交易指令仍有效。
      </p>
      <p class="footer-tips">
        若您为中国银行持卡人，使用中国银行借记卡进行快捷支付，您还同意与中国银行股份有限公司签订《中国银行股份有限公司借记卡快捷支付服务协议》，并通过网络页面或手机客户端界面等点击或以其他方式同意/确认/接受《中国银行股份有限公司借记卡快捷支付服务协议》的全部内容。
      </p>
    </section>
    <section class="bank-cell">
      <p class="sub-title">中国银行股份有限公司借记卡快捷支付服务协议</p>
      <p>请客户认真阅读本协议文本。</p>
      <p>
        1.中国银行股份有限公司借记卡快捷支付业务（以下简称“快捷支付业务”）是中国银行股份有限公司（以下简称“中国银行”）和商盟商务服务有限公司（下称“合作支付机构”）联合为中国银行借记卡持卡客户（以下简称“客户”）提供的一项电子支付服务。凡是持有中国银行股份有限公司在中国大陆地区发行的借记卡的客户，均可申请该业务。
      </p>
      <p>
        2.客户在签约快捷支付业务时，将收到中国银行发送的带有手机交易码的签约确认短信。客户应认真阅读本协议，在同意本协议约定内容的前提下输入手机交易码。客户输入手机交易码即视同为同意本协议内容。
      </p>
      <p>
        <strong
          >3.客户通过互联网（Internet）在合作支付机构网站或客户端，选择在线与中国银行签订本服务协议，将指定的借记卡与此时登录的账户进行关联，开通快捷支付功能，并承担由此产生的一切责任。</strong
        >
      </p>
      <p>
        4.客户同意，中国银行以<strong>合作支付机构</strong>传送至中国银行的户名、卡号、手机号码、<strong>证件号码</strong>等身份要素作为确认客户身份、为客户开通快捷支付业务的唯一证据。中国银行比对户名、卡号、手机号码、证件号码与客户在银行预留信息一致后，通过<strong>95566</strong>发送手机交易码至客户预留手机号上，并对<strong>合作支付机构</strong>传送的客户填写的手机交易码进行验证，验证一致通过后，完成客户指定的借记卡与此时所登录账户的关联。<strong>客户须保证在中国银行预留手机号码为本人手机号码并确保其准确性。</strong>基于提高交易安全的目的，中国银行有权变更上述身份要素。客户须妥善保管本人中国银行借记卡信息，本人身份信息、手机交易码、安全认证工具等敏感信息，不得将敏感信息向他人透露。<strong
          >因客户银行预留信息错误，或个人信息、手机等保管不善产生的风险及损失由客户本人承担。</strong
        >
      </p>
      <p>
        5.开通快捷支付业务后，客户同意并授权中国银行在本协议约定的服务范围内，将其所关联借记卡的原有支付验证方式变更为按照<strong>合作支付机构</strong>发送的交易指令从客户指定的借记卡账户中支付相应款项。客户需在其绑定的借记卡的余额内进行支付，否则中国银行有权拒绝执行交易指令。
      </p>
      <p>
        6.中国银行可根据业务发展需要，设置或修改支付限额，客户对此无异议，客户办理快捷支付业务时需同时受中国银行和<strong>合作支付机构</strong>设置的支付限额的约束。在任何情况下，支付金额不应超过中国银行或<strong>合作支付机构</strong>设置的支付限额（以较低者为准）。如实际支付金额大于规定的支付限额，中国银行将拒绝执行交易指令。
      </p>
      <p>
        7.本协议项下，中国银行仅提供通过<strong>合作支付机构</strong>发生的支付结算服务。<strong
          >客户因通过合作支付机构购买商品而产生的一切关于商品或服务质量、商品交付，交易款项扣收与划付的争议均由客户与商户或商品/服务的实际销售商自行协商解决。</strong
        >
      </p>
      <p>8.客户使用借记卡快捷支付业务应防范的风险包括但不限于：</p>
      <p style="text-indent: 2em;">
        （1）客户借记卡快捷支付使用的用户名、账户、密码等重要信息可能被其他人猜出、偷窥或通过木马病毒、假冒网站、欺诈电话或短信等手段窃取，从而导致客户信息泄露、资金损失、账户被恶意操作等后果。
      </p>
      <p style="text-indent: 2em;">
        （2）手机可能被盗或未经许可被他人使用，若手机银行密码同时被窃取，可能造成账户资金损失等情况；若客户更换手机号时未取消以原手机号开通的短信提醒服务，当原手机号被他人使用时，可能造成客户的账户信息泄露等情况。
      </p>
      <p style="text-indent: 2em;">
        （3）客户使用设备的操作系统、杀毒软件、网络防火墙等客户端软件未及时更新或安装补丁程序，可能导致客户信息泄露、资金损失、账户被恶意操作等后果。
      </p>
      <p>
        9.
        客户应采取风险防范措施，安全使用借记卡快捷支付业务，相关措施包括不限于：
      </p>
      <p style="text-indent: 2em;">
        （1）妥善保护借记卡快捷支付业务使用的用户名、账户、密码等重要身份识别标识、身份认证信息及工具，确保上述重要信息和认证工具不经口头或其它方式发生泄露或被盗用。
      </p>
      <p style="text-indent: 2em;">
        （2）对所使用设备的操作系统、杀毒软件、网络防火墙等客户端软件采取有效的措施（如及时更新系统或安装补丁程序等）防范操作系统软件漏洞风险、电子设备中的病毒等。
      </p>
      <p style="text-indent: 2em;">
        （3）妥善保管借记卡、手机及与借记卡快捷支付业务相关的重要身份证件等资料，不交给其他人保管，不放置在不安全场所。
      </p>
      <p style="text-indent: 2em;">
        （4）避免使用容易被其他人猜出或破解的密码（如：采用生日、电话号码等与个人信息相关的信息或具有规律性的数字或字母组合作为快捷支付业务密码），避免设置与其他用途相同的密码（如：采用电子邮件密码作为借记卡快捷支付密码）。客户应定期或不定期更新其密码。
      </p>
      <p style="text-indent: 2em;">
        （5）
        应经常关注账户内资金变化，如发现任何通过中国银行借记卡快捷支付从事的未经客户许可的操作及交易，客户应马上与支付机构或中国银行取得联系。
      </p>
      <p>
        10.借记卡快捷支付业务资金清算可能出现异常及差错交易，银行及合作支付机构将对异常及差错交易及时进行纠正处理。银行及合作支付机构将根据客户要求提供交易记录的时间和方式等信息。
      </p>
      <p>
        11.客户不得利用中国银行快捷支付业务进行虚假交易、洗钱、诈骗、恐怖融资等行为，且有义务配合中国银行进行相关调查，一旦客户拒绝配合进行相关调查或中国银行认为客户存在或涉嫌虚假交易、洗钱或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，中国银行有权采取以下一种、多种或全部措施：（1）暂停或终止提供本协议项下快捷支付业务服务；（2）终止本协议；（3）取消客户的用卡资格。
      </p>
      <p>
        12.客户同意中国银行就快捷支付业务的开展，向支付机构提供客户留存在中国银行的户名、银行卡号、<strong>证件号码</strong>、手机号码等信息。
      </p>
      <p>
        13.客户可以登录中国银行官方网站撤销本人名下指定借记卡与支付机构账户关联的快捷支付功能。
      </p>
      <p>
        14.中国银行系统升级、业务变化、收费变更，或根据业务发展需要修改本协议，中国银行将提前进行公告。若客户有异议，有权选择撤销相关服务，若客户选择继续接受该服务的，视为客户同意并接受相关业务或协议按变更或修改后的内容执行。双方同意，本协议所称公告均指在中国银行网点、中国银行网站<strong>【http://www.boc.cn】</strong>、电子银行渠道等进行公告。
      </p>
      <p>
        <strong
          >15.选择打勾的客户，视同已通读上述条款，对条款的内容及其后果已充分理解，对所有内容均无异议。</strong
        >
      </p>
      <p>
        本协议在客户于支付机构提供的页面服务协议栏位打勾并提交后生效。本协议的生效、履行及解释均使用中华人民共和国法律（为本协议之目的，不含中国香港、澳门、台湾地区法律）。本协议项下的争议向中国银行所在地人民法院起诉。
      </p>
      <p class="footer-tips" style="text-indent: 2em;">
        若您为中国银行持卡人，使用中国银行贷记卡进行快捷支付，您还同意与中国银行股份有限公司签订《中国银行信用卡快捷支付业务线上服务协议》，并通过网络页面或手机客户端界面等点击或以其他方式同意/确认/接受《中国银行信用卡快捷支付业务线上服务协议》的全部内容。
      </p>
    </section>
    <section class="bank-cell china-quick">
      <p class="sub-title">中国银行信用卡快捷支付业务线上服务协议</p>
      <p>
        <strong
          >在接受本协议之前，请您仔细阅读本协议的全部内容（特别是以粗体标注的内容）。如果您不同意本协议的任何内容，或者无法准确理解相关条款的解释，请不要进行后续操作。</strong
        >如有疑义,请及时拨打中国银行信用卡客户服务热线4006695566咨询或（8610）66085566。
      </p>
      <p>
        为规范双方业务行为，本协议由甲方（中国银行信用卡个人客户）、乙方（中国银行股份有限公司）本着平等互利的原则，就信用卡快捷支付业务相关事宜达成本协议。甲方通过互联网（Internet）点击确认并接受本协议，在线与乙方签订本服务协议，开通商盟商务服务有限公司（统统付）快捷支付业务功能并承担由此产生的一切责任。
      </p>
      <p>第一条 业务定义</p>
      <p>
        中国银行股份有限公司信用卡快捷支付业务（以下简称“快捷支付业务”）是乙方和商盟商务服务有限公司（统统付）向甲方提供的，将甲方信用卡与统统付账户签约绑定后，乙方即可根据统统付发送的指令，扣划甲方信用卡账户资金的支付服务业务。
      </p>
      <p>第二条 权利和义务</p>
      <p>
        一、“快捷支付”签约的信用卡为甲方本人申请并使用，保证在签约过程中提供的信息真实、准确、有效，确保支付行为合法，并未侵犯任何第三方合法权益，否则因此给乙方或第三方造成损失的，<strong
          >由甲方负责赔偿并承担全部法律责任。</strong
        >
      </p>
      <p>
        <strong
          >二、甲方同意将签约过程中填写的卡号、有效期、卡片验证码、客户姓名、公民身份证号码、手机号码和手机动态密码等要素作为确认甲方身份，并同意将指定信用卡卡号与甲方在统统付注册的会员账号建立签约关系。乙方收到统统付发送的上述信息后，验证上述信息与甲方在乙方预留的信息一致后，即视为获得甲方的有效授权，乙方可根据统统付的指令直接从该信用卡中扣除相应款项直至终止绑定为止（终止绑定指甲方通过统统付或直接通过乙方渠道发出指令，解除信用卡快捷支付签约关系；或因甲方签约时填写的信息发生变动导致的签约关系解除）。基于提高交易安全的目的,乙方有权变更验证流程和上述要素作为验证标准的权利。</strong
        >甲方须妥善保管本人中国银行信用卡卡片信息、本人身份信息、手机动态密码、安全认证工具、交易信息等敏感信息，不得将敏感信息向他人透露。<strong
          >因甲方个人信息、信用卡卡片信息、手机等保管不善产生的风险及损失由甲方本人承担，并承担因此给乙方或第三方造成的损失。</strong
        >
      </p>
      <p>
        <strong
          >三、“快捷支付”签约成功后，即视为甲方授权乙方按照统统付的交易指令从签约的信用卡上主动扣划资金。</strong
        >甲方不应以未在交易单据中签名、签名不符、非本人意愿交易、未验证信用卡支付密码等原因否认交易、要求乙方退款或承担责任。
      </p>
      <p>
        四、乙方可根据业务发展需要，设置或修改支付限额，甲方对此无异议。任何情况下，甲方的支付限额不应超过乙方及统统付设置的支付限额（以较小者为准），同时也受限于信用卡支付额度。如实际支付金额大于支付限额，乙方有权拒绝执行统统付发送的交易指令。
      </p>
      <p>
        五、甲方不得利用信用卡快捷支付业务进行套现、虚假交易、洗钱等行为，且有义务配合乙方进行相关调查，一旦甲方拒绝配合进行相关调查或乙方认为存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，乙方有权采取以下一种、多种或全部措施：
      </p>
      <p>（1）暂停或终止提供本协议项下统统付快捷支付服务；</p>
      <p>（2）终止本协议；</p>
      <p>（3）中国银行股份有限公司信用卡领用合约、章程中约定的相关措施。</p>
      <p>
        <strong
          >六、甲方授权并同意乙方就统统付快捷支付业务向统统付提供甲方留存在乙方的卡号、有效期、卡片验证码、客户姓名、公民身份证号码、手机号码等信息的验证服务。并已知晓上述服务可能会使相关服务合作方据此知悉甲方的相关信息。
        </strong>
      </p>
      <p>
        七、乙方仅为甲方提供安全、可靠的支付结算服务。甲方因通过统统付或其合作方购买商品而产生的一切关于商品或服务质量、商品交付、交易款项扣收与划付的争议均由甲方与商品或服务的实际销售商以及统统付自行协商解决，与乙方无关。
      </p>
      <p>第三条 协议的效力</p>
      <p>
        <strong
          >一、因乙方对银行系统进行升级、改造而引起的服务取消、暂停或者服务内容、项目、方式等变化，或根据业务发展需要修改本协议、服务时间或其他业务规则，乙方将在乙方网站【http://www.boc.cn】等提前进行公告，不再逐一通知甲方，若甲方拒绝此修改，有权在公告规定的合理时间内注销相关服务，若甲方在公告的业务变更或协议修改生效日期后未注销相关服务，即视为甲方同意并接受该变更或修改。</strong
        >
      </p>
      <p>
        二、本协议终止后，统统付在协议终止前已发送的交易指令仍有效，客户应承担其后果。
      </p>
      <p>
        <strong
          >三、本协议自甲方在统统付的网站点击“确认”后生效。对带有加粗的条款的内容及其后果已充分理解，对所有内容均无异议。</strong
        >
      </p>
      <p>四、本协议的生效、履行及解释均适用中国法律。</p>
      <p>
        五、甲乙双方在履行本协议时发生的争议，由双方友好协商；协商不成，任何一方均可提交为甲方开立本协议项下绑定信用卡的乙方分支机构所在地有管辖权的人民法院诉讼解决。
      </p>
      <p class="footer-tips">
        若您为中国工商银行持卡人，使用中国工商银行银行卡（借记卡/信用卡）进行快捷支付，您还同意与中国工商银行股份有限公司签订《中国工商银行快捷支付业务服务协议》，并通过网络页面或手机客户端界面等点击或以其他方式同意/确认/接受《中国工商银行快捷支付业务服务协议》的全部内容。
      </p>
    </section>
    <section class="bank-cell">
      <p class="sub-title">中国工商银行快捷支付业务服务协议</p>
      <p>
        <strong
          >在接受本协议之前，请您仔细阅读本协议的全部内容（特别是以粗体标注的内容）。如有疑义请及时通过工商银行网站或拨打客户服务热线（95588）咨询。如您不同意本协议的任何内容，或者不能准确理解本协议的任何条款，请不要进行后续操作。</strong
        >
      </p>
      <p>
        为明确双方的权利和义务，规范双方业务行为，甲方（个人客户）、乙方（中国工商银行）本着平等互利的原则，就快捷支付业务相关事宜达成本协议。甲方通过互联网（Internet）点击确认或以其他方式选择接受本协议，即表示甲方同意接受本协议的全部约定内容，确认承担由此产生的一切责任。
      </p>
      <p><strong>第一条 业务定义 </strong></p>
      <p>下列用语在本协议中的含义为：</p>
      <p>
        “快捷支付”是指乙方与商盟商务服务有限公司（下称‘非银行支付机构’）向甲方提供的，将甲方银行卡与支付账户签约绑定后，乙方即可根据非银行支付机构发送的指令，扣划甲方银行卡账户资金的支付服务业务。
      </p>
      <p>
        "快捷支付"的签约和使用渠道包括但不限于：计算机、手机、电话、掌上电脑、电视、自助终端等设备，具体以乙方及非银行支付机构提供的快捷支付业务为准。
      </p>
      <p>
        <strong
          >"手机号码"指甲方在乙方开立银行账户时预留信息中的手机号码或者甲方在乙方认可的第三方机构（例如电信运营商等）办理的本人手机号码。</strong
        >
      </p>
      <p><strong>第二条 权利和义务 </strong></p>
      <p>
        一、甲方应确保用于"快捷支付"签约的银行卡为本人所有，保证在签约过程中提供的信息真实、准确、有效，确保支付行为合法并未侵犯任何第三方合法权益，否则因此造成乙方及其持卡人损失的，由甲方负责赔偿并承担全部法律责任。
      </p>
      <p>
        <strong
          >二、甲方同意将签约过程中所填写的包括但不限于姓名、银行卡号、手机号码、身份证件号码、信用卡有效期用于身份验证，并同意将指定银行卡号与甲方在非银行支付机构开立的指定支付账号建立签约关系。</strong
        >乙方收到非银行支付机构发送的上述信息后，将上述信息与甲方在乙方预留的客户信息进行比对验证，验证通过后，乙方为甲方签约银行卡开通快捷支付业务。<strong>甲方同意乙方将上述信息发送至乙方认可的第三方机构（中国联合网络通信有限公司内蒙古自治区分公司，客服电话：10010）进行信息查询与核验。</strong>乙方承诺对甲方签约信息保密，但法律法规和规章另有规定或监管部门等有权机关另有要求的除外。<strong
          >甲方同意乙方可根据业务需要变更验证流程、要素和验证标准。</strong
        >
      </p>
      <p>
        三、乙方与非银行支付机构合作，为甲方提供不同的服务开通方式，为了开通快捷支付服务或交易风险短信验证所必需，甲方同意乙方将姓名、银行卡号、手机号码、身份证件号码、信用卡有效期发送至非银行支付机构（联系方式请见非银行支付机构官方网站公布）。
      </p>
      <p>
        <strong
          >四、"快捷支付"签约成功后，即视为甲方授权乙方按照非银行支付机构的交易指令从签约银行卡上主动扣划资金。甲方同意，交易中产生的未在交易单据中签名、签名不符、非本人意愿交易、未验证银行卡支付密码、未验证银行卡支付盾等不要求乙方退款或承担其他责任。</strong
        >
      </p>
      <p>
        五、甲方应妥善保管银行卡开户户名、开户类型、与之相关的证件类型及证件号码、手机号码、固定电话、通信地址等相关信息，如遗失银行卡或泄露上述相关信息，甲方应及时通知乙方并办理挂失或销户等相关手续，减少可能发生的损失。<strong
          >挂失或销户前的损失，以及因甲方泄露银行卡密码、非银行支付机构支付账户登录名或与非银行支付机构约定的其他各类密码、动态验证码、数字证书、U盾、丢失银行卡等所致损失，由甲方自行承担。</strong
        >
      </p>
      <p>
        六、甲方可通过乙方网上银行等渠道自助查询"快捷支付"业务签约情况并对卡账户支付限额进行管理。甲方设置的支付限额不应超过乙方及非银行支付机构设置的最大支付限额，如实际支付金额大于支付限额，乙方有权拒绝执行交易指令。乙方保留根据交易安全需要设置或修改最大支付限额的权利。信用卡支付限额同时受限于卡信用额度。Ⅱ类、Ⅲ类账户受账户自身限额限制。
      </p>
      <p>
        七、甲方不得利用快捷支付业务进行套现、虚假交易、洗钱等违法行为，有义务配合乙方进行相关调查。如若甲方拒绝配合进行相关调查或乙方认为存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，乙方有权采取以下一种、多种或全部措施：（1）暂停或终止提供本协议项下快捷支付服务；（2）终止本协议；（3）取消甲方的用卡资格。若因甲方的前述行为而给乙方造成损失的，甲方应负责赔偿并承担法律责任。
      </p>
      <p><strong>第三条 法律适用条款 </strong></p>
      <p>
        本协议的成立、生效、履行和解释，均适用中华人民共和国法律（除香港、澳门、台湾地区法律）；法律无明文规定的，可适用通行的金融惯例。
      </p>
      <p>
        本协议是乙方的其他既有协议和约定的补充而非替代文件，如本协议与其他既有协议和约定有冲突，应以本协议为准。
      </p>
      <p><strong>第四条 差错和争议的解决</strong></p>
      <p>
        乙方仅为甲方提供安全可靠的支付结算服务，依据非银行支付机构提供的交易指令实施资金扣划。对于因购买商品或服务而产生的一切关于商品、服务及费用扣收的争议均由甲方与非银行支付机构自行协商解决，与乙方无关。
      </p>
      <p>
        双方在履行本协议的过程中，如发生争议，应尽量协商解决。协商不成的，任何一方均应向<strong>甲方绑定银行卡的开户行所在地有管辖权的人民法院</strong>提起诉讼。
      </p>
      <p><strong>第五条 协议的终止 </strong></p>
      <p>
        甲方可通过非银行支付机构网站或乙方网上银行、手机银行主动发起解除签约关系的申请。"快捷支付"签约关系一旦解除，本协议即告终止。协议终止前已发送乙方处理的交易指令仍有效，甲方应承担相应后果。
      </p>
      <p>
        <strong
          >如因签约卡/折注销、补（换）卡/折等任何原因导致卡/折号变更，须重新签订"快捷支付"签约关系。</strong
        >
      </p>
      <p><strong>第六条 协议的效力 </strong></p>
      <p>
        <strong
          >本协议与本行借记卡或贷记卡章程或协议约定不一致的，以本协议为准。
        </strong>
      </p>
      <p>
        <strong
          >甲方同意，乙方有权变更、暂停本协议项下快捷支付业务服务，有权修改、终止本协议，并于执行前通过乙方网站或营业网点、95588短信等形式进行公告。修改本协议的公告到期后甲方继续办理快捷支付业务的，视同接受有关本协议、快捷支付业务服务的修改内容。甲方不同意的，可以终止本协议。</strong
        >
      </p>
    </section>
    <section class="bank-cell china-quick">
      <p class="sub-title">
        中国邮政储蓄银行借记卡快捷支付业务线上服务协议
      </p>
      <p>
        尊敬的客户：为了维护您的权益，请您在同意接受本协议之前，仔细阅读本协议各条款，特别是黑体字加粗的内容。如您不同意本协议条款或无法准确理解本协议的相关内容，请勿进行下一步操作，请拨打邮储银行客服及投诉热线：95580，以便我们向您解释咨询。您通过点击签约页面确认的方式选择签订本服务协议，即表示您确认接受本协议的全部内容，同意开通快捷支付业务功能并承担由此产生的相关法律责任。
      </p>
      <p>
        <strong>一、业务定义</strong>
      </p>
      <p>
        中国邮政储蓄银行借记卡快捷支付业务是中国邮政储蓄银行（以下简称“邮储银行”）和商盟商务服务有限公司（以下简称“非银行支付机构”）联合为邮储银行借记卡个人客户（以下简称“您”）提供的，将邮储银行卡与支付账户签约绑定后，邮储银行即可根据非银行支付机构发送的指令，从您指定的借记卡账户中划扣相应款项的支付服务业务。凡是持有邮储银行借记卡且同时为非银行支付机构用户的客户，均可申请该业务。
      </p>
      <p>
        <strong>二、权利和义务</strong>
      </p>
      <p>
        <strong>
          1.您同意邮储银行以非银行支付机构传送至邮储银行的姓名、银行卡号、身份证件号码、手机号码和手机短信验证码作为确认客户身份、为客户开通非银行支付机构快捷支付业务的唯一依据。</strong
        >为了开通快捷支付业务或交易风险短信验证所必需，您同意邮储银行将<strong>姓名、银行卡号、身份证件号码、手机号码</strong>发送至非银行支付机构（联系方式请见非银行支付机构官方网站公布）。您需确保您所提供的姓名、银行卡号、身份证件号码、手机号码等信息真实有效。
      </p>
      <p>
        <strong
          >2.您应保证业务开通时在邮储银行预留的手机号码为本人手机号码，否则由此导致的损失，邮储银行不承担赔偿责任。您须妥善保管本人邮储银行借记卡信息、身份信息、手机短信验证码、安全认证工具等敏感信息，不得将敏感信息向他人透露。因您的个人信息、银行卡片信息、手机等保管不善产生的风险及损失由您本人承担。</strong
        >
      </p>
      <p>
        <strong
          >3.您同意并授权邮储银行在校验您的手机短信验证码通过后，按照非银行支付机构的交易指令从您指定的借记卡账户中支付相应款项，您对此交易验证方式及交易规则无异议。</strong
        >
      </p>
      <p>
        4.为确保您的网上支付资金安全，邮储银行有权设置或修改支付限额。您在支付时需同时受邮储银行和非银行支付机构设置的支付限额的约束，<strong>如您实际支付金额大于规定的支付限额，邮储银行将拒绝执行该笔交易。</strong>如您需查看支付限额，可在邮储银行相关渠道或者非银行支付机构端进行查询。
      </p>
      <p>
        5.您承诺在指定的银行付款账户中保留足够的余额，并保持账户处于正常状态。<strong
          >因付款账户余额不足、账户被冻结、销户等非我行原因而导致的无法成功支付费用及所造成的纠纷和违约责任、损失等，您在符合法律法规要求的范围内自行承担法律后果。</strong
        >
      </p>
      <p>
        6.<strong>您不得利用邮储银行非银行支付机构快捷支付业务进行套现、虚假交易、洗钱、非法融资等行为，且有义务配合邮储银行进行相关调查，如在快捷支付业务签约期间出现监管机关规定的或邮储银行认定的风险特征时，邮储银行有权采取以下一种或多种措施：</strong>（1）暂停或终止提供本协议项下非银行支付机构快捷支付业务；（2）终止本协议；（3）取消您的用卡资格。根据相关法律约定，您需对提供给邮储银行资料的真实性、有效性及取得资料的合法性负责，并同意邮储银行将上述资料、信息用于洗钱风险管理。
      </p>
      <p>
        7.因<strong>非邮储银行原因以及邮储银行无法控制和不可预测的原因造成的电力中断、电脑、网络等通讯故障，或不可抗力等因素</strong>导致非银行支付机构快捷支付业务中断或者处于不稳定状态，邮储银行已尽力采取补救措施但仍未能避免损失的情况下，不承担相关责任。
      </p>
      <p>
        8.为了及时、准确地完成签约及快捷支付，并满足反洗钱等监管要求，<strong>您理解并同意邮储银行需要记录您使用本服务的用户实名认证信息、银行卡信息、交易信息。</strong>在您使用本服务期间或本服务终止后，您理解并同意邮储银行在相关法律法规或监管要求的必要期限内留存您在开通及使用本服务过程中产生的相关数据。
      </p>
      <p>
        <strong>
          三、差错和争议的解决
        </strong>
      </p>
      <p>
        <strong
          >1.邮储银行不对非银行支付机构提交的扣款交易指令进行实质性审核，不负责审核非银行支付机构提交扣款指令的真实性、合法性、准确性。如您对邮储银行依据非银行支付机构指令进行扣款的行为存在异议，应与非银行支付机构协商解决。</strong
        >
      </p>
      <p>
        <strong
          >2.邮储银行仅为您提供安全可靠的支付结算服务。您因通过非银行支付机构或非银行支付机构商户购买商品而产生的一切关于商品或服务质量、商品交付的争议，由您与商品/服务的实际销售商以及非银行支付机构自行协商解决。</strong
        >
      </p>
      <p>
        3.本协议自您在快捷支付业务开通页面点击确认后立即生效。本协议的生效、履行及解释均适用中国法律。<strong
          >因本协议产生任何争议，双方应友好协商解决；协商不成的，任何一方有权向被告住所地有管辖权的人民法院提起诉讼。</strong
        >
      </p>
      <p>
        <strong>
          四、协议的效力
        </strong>
      </p>
      <p>
        1.<strong>邮储银行有权变更、暂停或终止本协议，但必须于执行前通过邮储银行网站（http://www.psbc.com/cn/）或营业网点、短信等方式进行公告。您在公告执行后继续办理非银行支付机构快捷支付业务的，视同接受有关本协议和非银行支付机构快捷支付业务服务修改、变更的内容。</strong>对相关条款如有异议，您可以在履行本协议项下应尽义务后解除本协议，并通过邮储银行手机银行或者非银行支付机构端解除快捷支付签约关系。
      </p>
      <p>
        2.如邮储银行与非银行支付机构业务合作终止，自终止之日起本协议自动失效。如您需注销快捷支付业务，可以通过非银行支付机构端发起注销申请，业务注销自邮储银行同意并在银行系统中设置成功后生效。
      </p>
      <p>
        3.如因签约卡注销、补（换）卡等任何原因导致卡号变更或失效，视同原快捷支付服务签约关系解除，需须重新签约。
      </p>
      <p>
        <strong>
          五、用户信息授权
        </strong>
      </p>
      <p>
        <strong
          >您知悉上述您授权的个人信息属于您的敏感信息，一旦泄露可能对您的权益产生影响或风险。</strong
        >您可通过邮储银行营业网点查询、复制、更正、补充、删除等上述您授权的个人信息，及通过解约方式撤回上述授权。当您撤回同意邮储银行处理有关您本人信息后，邮储银行将不再处理您相应的个人信息，但您理解，您撤回同意的决定不会影响撤回前基于您的同意已开展的个人信息的处理。如果您拟撤回同意的信息属于邮储银行提供服务的必要信息，您应在邮储银行提供相关服务前或相关服务终止后再进行撤回。
      </p>
    </section>
    <section class="common-cnt">
      <p class="sub-title">
        中国建设银行非银行支付机构快捷支付业务客户授权协议
      </p>
      <p>甲方：个人客户</p>
      <p>乙方：中国建设银行股份有限公司_____分支行</p>
      <p>
        业务定义
      </p>
      <p>
        客户：指在本协议中授权乙方对其建设银行账户进行扣款的个人客户，本协议中指甲方。
      </p>
      <p>
        支付机构：非银行支付机构（以下简称“支付机构”）是指依据中国人民银行《非金融机构支付服务管理办法》规定，取得《支付业务许可证》，获准办理互联网支付业务的非金融机构，本协议中指______________。
      </p>
      <p>
        快捷支付：快捷支付是指依托清算机构转接开展的，乙方作为甲方账户的开户机构，甲方对乙方进行授权后，支付机构向乙方发送支付指令，扣划甲方在乙方的账户资金并通过清算机构划转至支付机构的业务。
      </p>
      <p>
        第二条 甲方的权利和义务
      </p>
      <p>
        1.甲方应拥有乙方账户，并遵守乙方关于账户的章程与约定。
      </p>
      <p>
        <strong>
          2.甲方应严格遵守乙方有关账户安全管理规定，不得将本人账户相关密码、短信验证码等重要信息向他人透露，否则由此导致的损失由甲方承担。
        </strong>
      </p>
      <p>
        <strong>
          3.甲方可以从乙方电子渠道发起的“快捷支付”签约，甲方同意支付机构将甲方填写的银行账号、开户户名、开户证件号码、在发卡行预留的手机号等要素发送至乙方用于身份验证，并同意通过发送短信验证码的方式完成甲方在乙方账户与支付机构的指定账户之间建立签约关系。</strong
        >乙方收到支付机构发送的上述信息后，将上述信息与甲方在乙方预留的客户信息进行比对验证，验证通过后，乙方为甲方签约银行卡开通“快捷支付”。
      </p>
      <p>
        <strong
          >4.甲方向乙方承诺:其向乙方提交身份信息、通过短信验证码方式进行授权、快捷支付签约行为均为甲方真实意愿表示，授权及签约指令真实、合法且有效，甲方已经充分了解和明确快捷支付业务扣款适用范围以及交易验证方式，甲方愿意承担相关法律后果</strong
        >
      </p>
      <p>
        <strong>
          5.甲方“快捷支付”签约成功后，即视为甲方授权乙方按照支付机构的交易指令从签约银行账户扣划资金。甲方不应以未在交易单据中签名、签名不符、非本人真实交易、未验证银行卡支付密码、未验证银行卡支付盾等原因要求乙方退款或承担其他责任。
        </strong>
      </p>
      <p>
        <strong>
          6.甲方可通过乙方电子渠道查询"快捷支付"业务签约情况，根据自身风险承受能力，自主设置与之承受能力相匹配的快捷支付业务单笔限额、单日限额。甲方在使用快捷支付服务时需同时受乙方和支付机构设置的最大支付限额约束，如实际支付金额大于支付限额，乙方将拒绝执行交易指令。乙方保留根据交易安全需要设置或修改最大支付限额的权利。信用卡支付限额同时受限于信用额度。II类、III类银行账户受账户自身限额限制。
        </strong>
      </p>
      <p>
        <strong
          >7.甲方不得利用“快捷支付”业务进行套现、虚假交易、洗钱等违法行为，有义务配合乙方进行相关调查。</strong
        >如若甲方拒绝配合进行相关调查或乙方认为存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，<strong>乙方有权采取以下一种、多种或全部措施：</strong>（1）暂停或终止提供本协议项下“快捷支付”服务；（2）终止本协议；（3）取消甲方的用卡资格。若因甲方的前述行为而给乙方造成损失的，甲方应负责赔偿并承担法律责任。
      </p>
      <p>
        第三条 乙方的权利和义务
      </p>
      <p>
        <strong
          >1.
          乙方根据甲方的授权和支付机构向乙方提交的支付扣款指令及支付扣款数据，直接从甲方指定的银行账号中扣缴相关费用至支付机构指定账户。</strong
        >
      </p>
      <p>
        <strong
          >2.
          乙方为保护资金安全，控制业务风险，可根据业务发展需要设置或修改支付限额。</strong
        >
      </p>
      <p>
        <strong
          >3.<strong>乙方有权随时变更甲方开通快捷支付后通过乙方进行电子支付时的身份验证方式，</strong>例如乙方可要求甲方在选择快捷支付时应当通过乙方网上银行或账号验证，或者使用网银盾或者短信验证码等方式作为校验标准。</strong
        >
      </p>
      <p>
        <strong
          >4.乙方有权依据国家有关规定及业务需要对服务内容、收费项目或标准、操作流程、客户须知等内容进行调整，涉及收费或其他客户权利义务变更的调整，将正式对外公告一定时期后执行并适用于本协议。</strong
        >如有需要，乙方将在公告前报经有关金融监管部门核准或备案；<strong
          >甲方有权在乙方公告期间选择是否继续使用相关服务，如果甲方不愿接受乙方公告内容的，应在公告施行前通过乙方渠道、支付机构二级商户或支付机构向乙方申请变更或终止相关服务；如果甲方未申请变更或终止相关服务，视为同意相关调整，变更后的内容对甲方产生法律约束力，若甲方不执行变更后的内容，乙方有权选择终止本项服务。</strong
        >
      </p>
      <p>
        第四条 特别约定条款
      </p>
      <p>
        1.甲方承诺在指定的乙方付款账户中保留足够的余额，并保持账户处于正常状态。<strong
          >因付款账户余额不足、账户被冻结、销户等原因而导致的无法成功支付费用及所造成的纠纷和违约责任、损失等法律后果由甲方承担。</strong
        >
      </p>
      <p>
        2.
        乙方仅为甲方提供支付结算服务，依据支付机构提供的交易指令实施资金扣划。<strong
          >甲方承诺：对于因购买商品或服务而产生的关于商品、服务及费用扣收的争议由甲方与支付机构自行协商解决。如因支付机构原因产生的风险事件，由甲方与支付机构协商解决。</strong
        >
      </p>
      <p>
        <strong
          >3.
          乙方接收到的扣款指令信息不明确、不完整、不清晰或无法辨认，导致乙方无法扣款的，乙方不承担责任，由甲方与支付机构协商解决。</strong
        >
      </p>
      <p>
        <strong
          >4.如甲方或支付机构向乙方传送的银行卡号、手机号码等信息有误，导致乙方不能按约定扣划资金或致使甲方及支付机构发生损失的，乙方不承担责任，由甲方与支付机构协商解决。</strong
        >
      </p>
      <p>第五条 信息安全。</p>
      <p>
        <strong
          >在乙方为甲方办理本协议项下事项所必需的情形下，甲方同意并授权乙方收集、存储甲方在办理本业务过程中主动提供或因使用服务而产生的个人信息，甲方同意并授权乙方可将上述信息用于业务办理、风险管理、监管机构调查、信息通知，甲方同意并授权乙方向乙方集团成员（包括建设银行境内全资子公司、控股子公司）、服务机构及其他必要的业务合作机构提供乙方获取的甲方个人信息。上述信息的范围包括甲方的基本信息、账户信息、交易信息及预留信息。</strong
        >
      </p>
      <p>
        <strong
          >对于甲方同意乙方处理的个人信息，乙方将按照法律法规、监管规定及与甲方的约定开展信息处理行为，并采取相应的安全措施保护甲方的个人信息。接收信息的上述第三方将为处理本协议项下事务之目的接触并按照乙方的业务需要使用甲方个人信息，乙方承诺将向有关第三方明确其保护甲方个人信息的职责并要求第三方承担相应保密义务。</strong
        >
      </p>
      <p>第六条 法律适用</p>
      <p>
        协议内各方在履行本协议的过程中如发生争议，应协商解决；
        <strong>协商不成的，向乙方住所地人民法院提起诉讼。</strong>
      </p>
      <p>
        本协议适用中华人民共和国法律。
      </p>
      <p>
        第七条 不可抗力
      </p>
      <p>
        因不可抗力（包括但不限于不能预见、不能避免并不能克服的战争、暴动、自然灾害、政府行为、社会事件、黑客攻击、供电、通讯、交易系统故障等客观情况）导致甲方损失的，乙方将视情况协助甲方解决或提供必要的帮助。根据不可抗力的影响，乙方部分或全部免除责任。
      </p>
      <p>
        第八条 协议签署与终止
      </p>
      <p>
        <strong>
          本协议经甲方在支付机构互联网或乙方手机银行APP及自助设备等渠道展示本协议的页面点击“同意”或“提交”按钮后生效。
        </strong>
      </p>
      <p>
        <strong>
          “快捷支付”签约关系一旦解除，本协议即告终止。协议终止前已发送乙方处理的交易指令仍有效，甲方应承担相应后果。如因签约卡/折注销、补（换）卡/折等原因导致卡/折号变更，甲方须重新签订"快捷支付"签约关系。
        </strong>
      </p>
      <p>
        <strong>
          特别提示：如客户对建设银行产品或服务有任何疑问、意见或建议，可通过拨打建设银行95533客户服务与投诉热线咨询与反映。
        </strong>
      </p>
      <p>
        <strong>
          甲方承诺：本人已仔细阅读上述所有条款，并已特别注意字体加黑的内容。中国建设银行已应本人要求对相关条款予以明确说明，本人对所有条款的含义及相应的法律后果已全部通晓并充分理解。
        </strong>
      </p>
    </section>
    <section class="bank-cell china-quick">
      <p class="sub-title">中信银行借记卡快捷支付线上服务协议</p>
      <p class="sub-title" style="margin: 0 0 20px 0; line-height: 12px;">
        （1.0版，2016年）
      </p>
      <p><strong>重要提示：</strong></p>
      <p>
        本协议是由<strong>中信银行股份有限公司</strong>（即本协议乙方）与乙方持卡人(即本协议甲方)就借记卡快捷支付服务的使用等相关事项所订立的有效合约。
      </p>
      <p>
        本协议项下“借记卡快捷支付服务”，指乙方为甲方提供的资金划转、支付服务，其目的是协助甲方便捷地完成货币资金合法支付、结算，但该服务存在因技术、不可抗力等原因造成的支付失败、无法结算等风险。
      </p>
      <p>
        甲方通过互联网（Internet）点击确认或以其他方式选择接受本协议，即表示同意接受本协议的全部约定内容，确认承担由此产生的一切责任。
      </p>
      <p>
        <strong
          >在接受本协议之前，请甲方仔细阅读本协议的全部内容（特别是以黑体标注的内容）。如果不同意本协议的任何内容，或者无法准确理解相关条款的解释，请不要进行后续操作。</strong
        >
      </p>
      <p>
        为明确双方的权利和义务，规范业务行为，双方本着平等互利的原则，就借记卡快捷支付服务相关事宜达成本协议。
      </p>
      <p>第一条 定义</p>
      <p>下列用语在本协议中的含义为：</p>
      <p>
        “本服务”指乙方根据本协议约定提供的借记卡快捷支付服务。本服务开通后，甲方在合作商户网站或相关使用界面输入快捷支付账户支付密码及收到的手机校验码后，<strong
          >即视为甲方确认支付金额及该支付指令，并同意由合作商户转交乙方进行后续处理。甲方同意并授权乙方按照合作商户的交易指令从甲方绑定的借记卡账户中支付相应款项，为此乙方不必事先通知甲方。如甲方借记卡内余额不足时，甲方知晓并同意乙方拒绝执行交易指令。</strong
        >
      </p>
      <p>“乙方”指本协议乙方，即中信银行股份有限公司。</p>
      <p>“甲方”指本协议甲方，即持有中信银行股份有限公司借记卡的持卡客户。</p>
      <p>
        “合作商户”指甲方选择购买商品或服务的企业商户，或为甲方提供相关服务的非金融支付机构。
      </p>
      <p>
        “借记卡”、“银行账户”指甲方在乙方开立的、用于开通借记卡快捷支付服务的银行借记卡及其对应银行账户。
      </p>
      <p>
        “快捷支付账户”指甲方在合作商户开立的、与“银行账户”绑定的支付账户。快捷支付账户的开通、管理由合作商户负责，具体权利义务内容以甲方与合作商户的约定为准。
      </p>
      <p>
        “身份信息及卡信息”指该开通快捷支付服务的借记卡、银行账户的开户户名、开户类型、与之相关的证件类型及证件号码、手机号码、固定电话、通信地址等与该借记卡有关的一切信息。
      </p>
      <p>
        “支付限额”指乙方或合作商户设置的对快捷支付服务支付金额的额度限制，以较低者为准。
      </p>
      <p>第二条 快捷支付服务的申请确认</p>
      <p>
        <strong
          >甲方确认并同意：乙方可向合作商户披露甲方在乙方登记的身份信息及卡信息</strong
        >，并对甲方在使用本服务过程中所填写的包括但不限于姓名、借记卡卡号、手机号码、身份证号码等进行校对核验；并同意将该借记卡与甲方此次登录的快捷支付账户进行绑定，以便甲方此次及今后进行支付。<strong
          >同时乙方与合作商户保留随时变更校验标准的权利。</strong
        >
      </p>
      <p>
        <strong
          >甲方确认并同意：乙方、合作商户为本服务的开通及使用（含甲方取消绑定或停止使用本服务或借记卡销户、借记卡挂失、补办新卡等情况）相互传递甲方的个人资料</strong
        >。甲方保证所提供的姓名、借记卡卡号、手机号码、身份证号码等信息真实有效，<strong
          >因甲方提供虚假信息而引起的法律责任由甲方承担。</strong
        >
      </p>
      <p>第三条 甲方权利义务</p>
      <p>一、权利</p>
      <p>
        （一）甲方自愿申请开通本服务，经乙方同意后，将有权享受快捷支付服务。
      </p>
      <p>
        （二）甲方有权办理本服务相关资料和信息变更、业务暂停、恢复和注销手续。
      </p>
      <p>
        （三）甲方对本服务如有疑问、建议或意见，有权致电乙方服务热线“95558”、登录乙方官方网站或到乙方各营业网点咨询。
      </p>
      <p>二、义务</p>
      <p>
        （一）甲方应按照我国相关法律、法规、规范性文件及乙方相关管理办法、交易规则及规章制度的规定，以及本协议的约定履行本协议。
      </p>
      <p>
        （二）甲方应在使用本服务过程中，<strong>认真核对短信校验码、商户名称、交易金额等信息是否与正在进行的交易事项一致</strong>，因交易信息与交易事项不一致而造成的一切损失，乙方不承担责任。
      </p>
      <p>（三）甲方同意不会将本服务使用权或连接权转移或转让他人。</p>
      <p>
        （四）<strong>甲方不得利用本服务进行套现、虚假交易、洗钱等行为，且有义务配合乙方进行相关调查</strong>。一旦甲方拒绝配合进行相关调查或乙方认为甲方存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，乙方有权根据本协议约定采取处理措施。
      </p>
      <p>
        <strong
          >（五）合作商户在本协议变更、终止前已接收并发送至乙方进行处理的交易指令仍有效，甲方应承担其后果。</strong
        >
      </p>
      <p>（六）甲方在本协议中应承担如下保密义务：</p>
      <p>
        1、甲方对在本服务中使用的密码、手机校验码、身份信息、卡信息以及乙方提供给甲方的任何信息（以下简称“保密信息”）负有妥善保管的义务，甲方应自行承担因该等保密信息泄密、遗忘以及其他因甲方未尽保管义务所导致的任何损失，乙方不负任何赔偿责任。
      </p>
      <p>
        <strong
          >2、甲方应按照以下原则设置和保管密码：避免使用姓名、生日、电话号码等与本人明显相关的信息作为密码；不得将本人自设密码提供给除法律规定外的任何人；通过手机银行办理业务后，须将自设密码从手机上删除；采取其他合理措施，防止本人密码被窃取。由于违反上述要求造成密码泄露的后果应由甲方自行承担。</strong
        >
      </p>
      <p>
        3、凡使用密码进行的交易，均视为甲方本人所为，依据密码等电子数据信息办理的各类结算交易所产生的电子信息交易记录均为该项交易的有效凭证。
      </p>
      <p>
        4、如上述保密信息出现或可能出现遗失、被窃或被其他人知悉的情况时，甲方应立即通知乙方并办理挂失。在挂失生效前发生网上支付的损失由甲方自行承担，乙方不承担任何法律责任。
      </p>
      <p>
        （七）在使用本服务过程中，上述保密信息如有更改，甲方应及时至乙方营业网点或通过网上银行办理有关变更手续，办妥上述手续之前所产生的一切后果由甲方承担。
      </p>
      <p>（八）甲方不得以与合作商户发生纠纷为由拒绝支付应付乙方的款项。</p>
      <p>第四条 乙方权利义务</p>
      <p>一、权利</p>
      <p>
        （一）乙方有权根据甲方的资信情况，决定是否为甲方开通本服务。当乙方有合理理由认为甲方提供的资料有误、不实、陈旧或不完善时，乙方有权暂停或终止向甲方提供部分或全部服务，甲方将承担因此而产生的全部损失与责任。
      </p>
      <p>（二）乙方有权对本服务支付系统进行升级、改造。</p>
      <p>
        （三）乙方可根据业务发展需要，设置或修改借记卡的支付限额，甲方对此无异议。甲方在使用本服务时需同时受乙方和合作商户设置的支付限额的约束。在任何情况下，支付金额不应超过乙方或合作商户设置的支付限额（以较低者为准）。如单笔交易指令中的支付金额高于支付限额，甲方同意乙方有权拒绝执行该交易指令。
      </p>
      <p>
        （四）如甲方拒绝配合乙方进行虚假交易、洗钱、套现等相关活动的调查，或乙方认为甲方存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，乙方有权采取如下措施：
      </p>
      <p>1、暂停或终止提供本协议项下快捷支付服务；</p>
      <p>2、终止本协议；</p>
      <p>3、取消甲方的借记卡使用资格。</p>
      <p>
        <strong
          >（五）乙方保留向甲方收取使用本服务的服务费及对服务费进行调整的权利。收费方式及收费标准、优惠措施及其生效和终止日期等以乙方通过手机银行、网站、其他电子渠道或营业网点等适当方式公告的内容为准。收费标准变更的，乙方将在上述渠道提前进行公告，不再另行通知甲方。未经公告，乙方不得单方面提高收费标准。除非另有说明，对于上述服务费用，乙方有权从甲方在中信银行开立的任一账户中先行扣除。</strong
        >
      </p>
      <p>
        （六）甲方出现未按时支付本服务有关费用、不遵守乙方有关业务规定或存在恶意操作、诋毁、损害乙方声誉等情况的，乙方有权单方终止对甲方提供本服务，并保留追究甲方法律责任的权利。
      </p>
      <p>
        （七）乙方保有对本协议条款、条件进行修改、增删的权利，本协议如有修改、增删时，乙方会通过乙方网站公告变更事项。甲方可于任何时间至乙方网站查询最新的服务合约，网址是http://bank.ecitic.com/
        ；或致电24小时客户服务热线95558。甲方在公告执行后继续使用快捷支付服务的，视同接受有关公告修改、变更的内容。
      </p>
      <p>二、义务</p>
      <p>
        （一）在乙方系统正常运行情况下，乙方负责及时准确地处理甲方或合作商户发送的交易指令，并及时向甲方提供查询交易记录、资金余额、账户状态等服务。但因合作商户反馈、传送的交易记录等信息有误，造成乙方查询结果错误的，乙方对此不承担责任，应由甲方与合作商户协商解决。
      </p>
      <p>
        （二）乙方负责向甲方提供本服务的咨询服务，并通过乙方手机银行、网站、其他电子渠道或营业网点公布功能介绍、热点问题解答、交易规则等内容。
      </p>
      <p>
        （三）乙方在法律法规许可和甲方的授权范围内使用甲方的资料和交易记录，但法律法规另有规定或监管机构要求乙方披露的除外。
      </p>
      <p>第五条 服务申明</p>
      <p>
        <strong
          >一、甲方应确保甲方在使用本服务时绑定的乙方借记卡为甲方本人合法所有，并确保甲方将甲方的快捷支付账户与银行账户绑定且用其支付的行为合法、有效，未侵犯任何第三方合法权益；否则因此造成乙方、持卡人损失的，甲方应负责赔偿并承担全部法律责任。</strong
        >
      </p>
      <p>
        <strong
          >二、因出现下列任一种情况导致甲方损失的，乙方均不承担任何赔偿责任：</strong
        >
      </p>
      <p>
        <strong
          >(一)因乙方接受到的指令信息不明、存在乱码、不完整，或者甲方的银行账户余额不足或账户被冻结、扣划等非乙方原因导致该等指令未被乙方执行；</strong
        >
      </p>
      <p>
        <strong
          >(二)因地震、台风、水灾、火灾、战争及其他不可抗力因素导致的甲方的损失；</strong
        >
      </p>
      <p>
        <strong
          >(三)因乙方不可预测或无法控制的系统故障、通讯故障、供电系统故障、计算机黑客袭击、电脑病毒、恶意程序攻击等突发事故，给甲方造成的损失；</strong
        >
      </p>
      <p>
        <strong
          >(四)因互联网传输原因，交易和转账指令出现中断、停顿、延迟、数据错误等情况以及乙方不可预测或不可控制因素造成的甲方的损失；</strong
        >
      </p>
      <p>
        <strong
          >(五)甲方使用的个人电脑等终端设备发生任何软件或资料的遗失、硬件的损害等进而导致的甲方的损失。
        </strong>
      </p>
      <p>
        <strong
          >(六)因甲方未准确核对短信校验码、商户名称、交易金额等信息而造成的甲方的损失。</strong
        >
      </p>
      <p>
        三、甲方通过本服务将银行账户内资金转出至快捷支付账户后，该转出资金的监管、计息将由合作商户负责，<strong
          >乙方不对转出资金进行计付利息、资金监管。</strong
        >
      </p>
      <p>
        四、本服务开通后，乙方以合作商户反馈的、甲方与合作商户之间的订单信息为准，为甲方进行资金划付处理，但资金划付结果不代表合作商户提供的商品及服务质量、物流结果、权益落实等相关信息，乙方对商品及服务的质量、物流状态等不负有任何责任。因该等商品及服务的质量、物流及权益落实等原因产生的纠纷由甲方与合作商户或其他第三方自行解决，与乙方无关，乙方不承担任何责任。
      </p>
      <p>第六条 协议终止</p>
      <p>
        一、甲方有权取消本服务。但在甲方取消本服务的终止验证申请生效之前，甲方通过本服务完成的交易仍属有效，甲方不得否认。
      </p>
      <p>
        二、若甲方违反本协议约定，乙方有权直接终止为甲方提供本服务，而无需事先通知。
      </p>
      <p>
        三、甲方在使用乙方借记卡的权利被终止时，甲方使用本服务的权利随同终止。
      </p>
      <p>
        四、甲方同意，如乙方与合作商户终止就本服务的合作，则本协议自动终止。
      </p>
      <p>第七条 差错处理</p>
      <p>
        因甲方未按本服务规定流程进行操作，或由于甲方自身的其他原因造成本服务指令未执行、未适当执行、延迟执行的，应及时拨打乙方服务热线“95558”或到营业网点通知乙方。<strong
          >乙方将积极调查并告知甲方调查结果，但不承担由此产生的损失的赔偿责任。</strong
        >
      </p>
      <p>第八条 法律适用及争议解决</p>
      <p>
        本协议的成立、生效、履行和解释，均适用中华人民共和国法律（为协议之目的，不包括港澳台地区法律）；法律法规无明文规定的，可适用通行的金融惯例。
      </p>
      <p>
        <strong
          >因本协议项下具体业务发生的争议，双方应协商解决。协商不成的，应由发生争议的具体快捷支付服务对应的借记卡开户分行住所地人民法院管辖。</strong
        >
      </p>
      <p>第九条 其它</p>
      <p>
        一、本协议签署后，若有关法律法规、规章制度及行业规章修订，相关内容及条款按新修订的法律法规、规章制度及行业规章办理，但本协议其他内容及条款继续有效。
      </p>
      <p>
        二、本协议所指的通知方式除上述条款中已有约定外，可以是书面送达通知或公告通知。
      </p>
      <p>
        书面送达通知、要求、诉讼（仲裁）的法律文书或其他通信，可交付或发送至本协议所约定的地址或联系方式。本协议项下乙方给予甲方的任何通知、要求或其他通信，其中电传、电话、传真、电子邮件等一经发出即视为已送达；邮政信函于投寄之日起第三日即视为已送达；如派人专程送达，则甲方签收日视为送达，甲方拒收的，送达人可采取拍照、录像方式记录送达过程，并将文书留置，亦视为送达。
      </p>
      <p>
        司法机关或仲裁机构亦按本协议约定的地址、联系方式向甲方发送相关（法律）文书，无人签收或甲方拒收的，则（法律）文书退回之日视为送达之日；如直接送达时甲方拒收的，送达人可采取拍照、录像方式记录送达过程，并将（法律）文书留置，亦视为送达。甲方提供错误联系方式或未及时告知变更后联系方式的，导致（法律）文书未能送达或退回的，则（法律）文书退回之日视为送达之日。
      </p>
      <p>
        如果甲方提供的上述联系方式发生变更的，应在变更后三日内书面通知乙方；否则按原联系方式发出的通知或其他文书，即使变更方没有收到，仍视为送达。
      </p>
      <p>公告通知自公告在指定报刊或乙方官方网站或经营场所发布之日起生效。</p>
      <p>三、本协议自乙方在电子银行系统为甲方完成本服务开通手续后立即生效。</p>
      <p>
        四、本协议是乙方的其他既有协议的补充而非替代性文件。本协议未尽事宜依照《中信银行人民币借记卡章程》、《中信银行外币借记卡客户须知（单币卡）》、《中信银行外币借记卡章程》、《中信银行个人电子银行业务章程》、《中信银行电子银行个人客户服务协议》及乙方就本服务及相关事项不时补充、制订的规定。如本协议与其他既有协议就本服务同一事项的约定冲突的，应以本协议为准。
      </p>
      <p>
        <strong
          >乙方已采取加粗、加黑、突出显示等合理方式提请甲方注意本协议项下免除或限制其责任的条款，并按甲方要求对有关条款予以充分说明；甲乙双方对本协议所有条款内容的理解不存在异议。</strong
        >
      </p>
    </section>
    <section class="bank-cell china-quick">
      <p class="sub-title">中信银行信用卡快捷支付服务协议</p>
      <p>
        本协议是由中信银行股份有限公司信用卡中心（以下简称“我行”）与我行持卡人(以下简称
        “您”)就统统付信用卡快捷支付服务（以下简称“本服务”）的使用等相关事项所订立的有效合约。<strong
          >您通过互联网（Internet）在页面上点击“确认”或以其他方式选择接受本协议，即表示您同意接受本协议的全部约定内容，确认承担由此产生的一切责任。</strong
        >
      </p>
      <p>
        在接受本协议之前，请您仔细阅读本协议的全部内容<strong>
          （特别是以粗体标注的内容）。如果您不同意本协议的任何内容，或者无法准确理解相关条款的解释，请不要进行后续操作。
        </strong>
      </p>
      <p>
        您应确保您在使用本服务时绑定的我行信用卡为您本人合法所有，并确保您将您的统统付账户与该信用卡绑定且用其支付的行为合法、有效，未侵犯任何第三方合法权益；否则因此造成我行、持卡人损失的，您应负责赔偿并承担全部法律责任。
      </p>
      <p>
        <strong>
          1、申请
        </strong>
      </p>
      <p>
        您确认并同意，我行可向商盟商务服务有限公司（<strong>以下简称</strong>“统统付”）披露您在我行登记的相关信息，并对<strong
          >您在使用本服务过程中所填写的包括姓名、信用卡卡号、手机号码、
          身份证号码等进行校对核验并以短信验证码方式对您的身份进行认证识别统统付对您的身份识别方式以您与统统付签订的相关协议条款为准。您同意将该信用卡与您此次登录的统统付账户进行绑定，以便您此次及今后进行支付。同时我行与统统付保留随时变更上述确认要素作为校验标准的权利。</strong
        >
      </p>
      <p>
        <strong
          >您同意我行、统统付为本服务使用并相互传递您的个人资料。您保证所提供的姓名、信用卡卡号、手机号码、身份证号码等信息真实有效，因您提供虚假信息而引起的法律责任由您承担。</strong
        >
      </p>
      <p>
        <strong
          >一旦绑定成功，即视为您同意并授权我行按照统统付的交易指令从您绑定的信用卡账户中支付相应款项，为此我行不必事先通知您。交易验证方式包括但不限于支付账户登录名或各类密码、生物识别技术、快捷协议号。如您信用余额不足时，您知晓并同意我行将拒绝执行交易指令。</strong
        >
      </p>
      <p>
        <strong
          >您如需取消绑定或停止使用本服务，可通过统统付客户端解除绑定，统统付将对应信息传递给我行，我行将停止为您提供快捷支付服务并解除卡片快捷支付绑定。</strong
        >
      </p>
      <p>2、使用</p>
      <p>
        (1)您对该信用卡开户户名、开户类型、与之相关的证件类型及证件号码、手机号码、固定电话、通信地址等与该信用卡有关的一切信息（以下简称“身份信息及卡信息”）
        以及一切涉及使用上述任何一项的活动或交易负保密责任。您同意不会将统统付信用卡快捷支付服务使用权或连接权转移或转让他人。如他人未经许可使用您的密码或其他验证资料，或违反任何其他保密程序，您在知晓后须立即按照申领合约中规定的通知程序或我行规定的其他程序通知我行。除非适用法律及条例或《中信银行信用卡（个人卡）领用合约》中另有规定，对持卡人因未能遵守此条款而产生的任何损失或损害，我行不须承担责任。<strong
          >因您泄露身份信息及或卡信息、密码、数字证书、U盾、丢失信用卡等所致损失需由您自行承担。</strong
        >
      </p>
      <p>
        (2)您同意，我行可根据业务发展需要，设置或修改信用卡的支付限额的权利，如有修改，您可通过我行网站查询最新公告或通过统统付客户端查看银行卡支付限额。您在使用本服务时需同时受我行和统统付设置的支付限额的约束。在任何情况下，支付金额不应超过我行或统统付设置的支付限额（以较少者为准，以下简称“支付限额”）。如实际支付金额大于支付限额，您知晓并同意我行将拒绝执行交易指令。
      </p>
      <p>
        (3)您不得利用统统付快捷支付业务进行套现、虚假交易、洗钱等行为，且有义务配合我行进行相关调查，一旦您拒绝配合进行相关调查或我行认为您存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，我行有权采取以下一种、多种或全部措施：a.暂停或终止提供本协议项下统统付快捷支付服务；b.终止本协议；c.取消您的信用卡使用资格。
      </p>
      <p>
        (4)
        您同意，我行保有对本服务合约条款、条件进行修改、增删的权利，本服务合约如有修改、增删时，会通过在本中心网站上公告变更事项。您可于任何时间至本中心网站查询最新的服务合约，网址是https://creditcard.ecitic.com/；或致电24小时客户服务热线
        40088－95558(未开通400业务地区和手机用户请拨打0755－82380730)。您在公告执行后继续办理或继续使用本服务的，视同接受有关本协议、快捷支付业务服务修改、变更的内容。本协议终止后，统统付在协议终止前已接收并发送我行进行处理的交易指令仍有效，您应承担其后果。
      </p>
      <p><strong>3、密码及安全</strong></p>
      <p>
        <strong
          >(1)您在本业务中使用的密码、手机校验码以及我行提供给您的任何信息都应视为机密，您负有妥善保管的责任，未尽保管责任所导致的损失，由您自行负责，我行不负任何赔偿责任。</strong
        >您同意并遵守：
      </p>
      <p>a.不让任何人知道上述密码、手机校验码等机密信息。</p>
      <p>
        b.采取最严格的方式保护上述密码、手机校验码等机密信息。例如：不将上述信息写在任何地方等。
      </p>
      <p>
        (2)凡使用动态密码或其他安全校验方式进行的交易，均视为您本人及附属卡持卡人本人所为，依据动态密码等电子数据信息办理的各类结算交易所产生的电子信息交易记录均为该项交易的有效凭证。
      </p>
      <p>
        (3)您同意若密码等机密信息发生遗失或被窃或被其他人知悉的情况时，应立即通知我行并完成必要的卡片挂失程序。上述通知或挂失程序完成前，若有任何他人使用此密码等机密信息的网上支付发生，我行不承担因此而产生的任何损失或者损害而引起的责任。上述通知或挂失程序完成后，不论您的密码等信息是否被使用，您的密码等机密信息都将被终止使用。若您具有与他人合谋或有其它欺诈行为，或者不配合我行调查的，则由您或附属卡持卡人承担所有损失。
      </p>
      <p><strong>4、服务申明</strong></p>
      <p>
        <strong> 在下列的任一种情况下，我行都不负责您的损失及损害赔偿：</strong>
      </p>
      <p>
        <strong>
          (1)网络传输过程中的资料遗失或延迟、网上支付失败等情况下不可归属于我行或本服务所直接或间接造成的损失。</strong
        >
      </p>
      <p>
        <strong
          >(2)您个人电脑发生任何软件或资料的遗失、硬件上的损害均与我行无关。</strong
        >
      </p>
      <p>
        <strong>(3)我行不保证您自网络上接受或传输的原始资料的真实性。</strong>
      </p>
      <p>5、赔偿及争议解决</p>
      <p>
        您利用本服务在网上支付所购买的任何商品或服务，纯属您与商户之间的买卖关系，不因您利用本服务而有所不同，我行无权对此买卖关系进行任何干预，亦无需承担任何责任。我行仅为您提供安全可靠的支付结算服务，依据统统付提供的交易指令实施资金扣划。双方在履行本协议的过程中，如发生争议，应尽量协商解决。协商不成的，任何一方均应向我行注册所在地有管辖权的人民法院提起诉讼。
      </p>
      <p>6、终止合约</p>
      <p>
        (1)您保有取消信用卡快捷支付服务使用的权利。在终止服务申请生效之前，利用信用卡快捷支付服务完成的交易仍属有效，您不得否认。
      </p>
      <p>
        (2)若您违反本合约事项，我行有权无需事先通知或催告，取消您使用信用卡快捷支付服务的权利；您与我行信用卡契约终止或使用信用卡的权利被终止时，您使用信用卡快捷支付服务的权利随同终止。
      </p>
      <p>
        <strong
          >(3)若您取消绑定或停止使用本服务，或信用卡销户、信用卡过期未办新卡、信用卡挂失未办新卡、信用卡升降级等情形导致原绑定的信用卡不能使用的，我行将停止为您提供快捷支付服务并解除卡片快捷支付绑定，本协议终止。同时，您同意我行将相关解除信息通知给统统付。</strong
        >
      </p>
      <p>
        (4)您同意，如我行与统统付终止本服务，则本协议自动终止并通过
        我行网站上公告变更事项。
      </p>
      <p><strong>7、协议的效力</strong></p>
      <p>
        <strong
          >(1)本合约事项于您完成我行信用卡快捷支付服务申请后立即生效。</strong
        >
      </p>
      <p>
        <strong
          >(2)本合约未尽事宜依照《中信银行信用卡（个人卡）领用合约》的规定，本合约已有约定与不符的，以本合约为准。《中信银行信用卡（个人卡）领用合约》预览网址https://creditcard.ecitic.com/heyue/new_wap/lingyong.html。</strong
        >
      </p>
      <p>
        <strong
          >(3)本合约即本服务中有关我行对您个人信息进行处理及保护的未尽事宜依照《动卡空间APP隐私政策》和《中信银行信用卡（个人卡）领用合约》的规定，与本合约已有约定不符的，以本合约为准。《动卡空间APP隐私政策》预览网址https://creditcard.ecitic.com/heyue/yinsitiaokuan.html。</strong
        >
      </p>
      <p>
        <strong
          >(4)本服务中统统付就其所承担的相应环节和内容对您负责，统统付对您个人信息处理及保护的事宜以您与统统付之间的协议为准。</strong
        >
      </p>
      <p><strong>8、其他</strong></p>
      <p>
        <strong
          >您确认，在您确认接受本协议前，您已仔细阅读、并充分理解了本协议的全部条款及其后果，对本协议的全部条款均无异议，并对本协议中的权利义务、责任限制及免责条款的含义和后果有准确无误的理解。您通过网络页面点击确认、或以其他方式选择接受本协议、或者使用本快捷支付服务，即表示您已与我行达成协议及接受本协议的全部内容。</strong
        >
      </p>
      <p>
        <strong>
          如果您不同意本协议的任何内容，或者无法准确理解相关条款的解释，请不要进行后续操作。
        </strong>
      </p>
    </section>
    <section class="bank-cell china-quick">
      <p class="sub-title">中国民生银行信用卡快捷支付业务用户协议</p>
      <p>
        1、本协议是由<strong>中国民生银行股份有限公司信用卡中心</strong>（以下简称“我行”）与我行持卡人(以下简称“您”)就民生信用卡（以下简称“信用卡”）快捷支付服务（以下简称“本服务”）的开通、使用等相关事项所订立的有效合约。<strong
          ><u
            >您通过互联网（Internet）点击确认或以其他方式选择接受本协议，即表示您已充分知晓并理解本协议条款的内容及相应后果，同意接受本协议的全部约定内容，确认承担由此产生的相应责任。</u
          ></strong
        >
      </p>
      <p>
        在接受本协议之前，请您仔细阅读本协议的全部内容（特别是以<strong
          ><u>粗体、下划线</u></strong
        >标注的内容）。<strong class="under-line"
          >如果您不同意本协议的任何内容，或者无法准确理解相关条款的解释，请不要进行后续操作。</strong
        >
        合作方平台：指非银行支付机构或者具有网络支付资质或收单业务资质的合作方，简称合作方平台。
      </p>
      <p>
        <strong class="under-line">
          您应确保您在使用本服务时绑定的我行信用卡为您本人合法所有，且该信用卡可正常使用（即不存在未激活、无效、信用额度不足等情形），并确保您将您在
          统统付（商盟商务服务有限公司） （下称“合作方平台”）（联系电话：
          4000128128
          ）的支付账户与该信用卡绑定且用其支付的行为合法、有效，未侵犯我行及任何第三方合法权益；否则因此造成我行、第三方损失的，您应负责赔偿并承担相应法律责任。
        </strong>
      </p>
      <p>
        2、本服务适用于我行信用卡，<strong class="under-line"
          >主卡和附属卡持卡人需要分别开通本服务。如信用卡卡片发生换卡等情况，新卡不自动使用本服务，使用时需另行开通。</strong
        >
      </p>
      <p>
        3、本服务系指我行和合作方平台共同向您提供的，将您的信用卡账户与合作方平台的支付账户进行绑定并开通快捷支付<strong>（完成绑定即开通本服务）</strong>，开通后每次支付时您在合作方平台渠道通过验证合作方平台支付账户即可完成款项支付的服务。
      </p>
      <p class="under-line">
        <strong>
          4、您同意并授权，为开通、使用本服务，为在开通、使用本服务时完成您的身份识别：
        </strong>
      </p>
      <p class="under-line">
        <strong>
          (1)
          在您通过合作方平台申请开通本服务期间，我行收集合作方平台收集并通过合法清算机构（中国银联股份有限公司联系电话：95516，网联清算有限公司联系电话：010-68148881，下同）转交我行的、您开通本服务过程中所填写的身份信息（包括姓名、信用卡卡号、手机号码、身份证号等，具体以清算机构规则规定为准），将前述信息与您在我行预留的个人信息进行对比核验，并进行短信验证码验证等身份验证，验证成功后，您同意并授权我行、合作方平台将该信用卡账户与您此次登录的合作方平台支付账户进行绑定，并授权我行将您选择并确认的银行卡信息、银行预留手机号信息发送给合作方平台；
        </strong>
      </p>
      <p class="under-line">
        <strong>
          (2）在您通过我行全民生活App申请开通本服务期间，我行将您选择并确认的银行卡信息以及个人相关信息（包括姓名、银行卡号、手机号码、身份证号码等，具体以清算机构规则规定为准）通过清算机构发送至您选择的合作方平台，由该合作方平台将前述信息与您在合作方平台预留的个人信息进行对比核验，并进行短信验证码验证等身份验证。合作方平台验证通过后，将您在合作方平台的支付账户信息发送给我行，您同意并授权我行、合作方平台将您选择并确认的支付账户与您指定银行账户绑定，并授权我行将前述支付账户与银行账户信息发送合作方平台。
        </strong>
      </p>
      <p class="under-line">
        <strong>
          您知悉并同意，我行与合作方平台保留变更上述确认要素作为校验标准的权利。您同意并授权，我行与合作方平台交互的前述个人信息（包括姓名、银行卡号、手机号码、身份证号码等验证要素，具体以清算机构规则规定为准）按照国家相关监管规定需通过清算机构进行转送，并授权合作方平台与我行相互提供前述相关信息进行交叉验证及客户身份验证，验证通过后，我行将客户在合作方平台设立的支付账号与客户指定的银行账户绑定。
        </strong>
      </p>
      <p>
        <strong class="under-line">
          您理解并同意：（1）一旦账户绑定成功，即视为您同意并授权我行按照合作方平台支付账户通过合法清算机构向我行发送的交易指令及您的信息（具体信息以清算机构规则规定为准）从您的信用卡上扣划相应款项。（2）您在合作方平台支付页面使用快捷支付密码或按您与合作方平台约定的其他合法方式向我行发送支付指令及您的信息（具体信息以清算机构规则规定为准），即视为您确认相关的交易及相应的支付金额及该支付指令，并由合作方平台转交我行进行后续处理。（3）按照上述指令及您的信息进行的交易将由您自行承担相应责任，但法律法规、监管规定另有要求的除外。您同意并授权我行按照前述交易指令及有关信息从您绑定的信用卡账户中支付相应款项，如您信用卡透支余额不足时，您知晓并同意我行将拒绝执行相关交易指令。本协议生效后您不应以任何不合理原因（包括但不限于我行未验证信用卡支付密码、您未在交易单据中签名、签名不符、非本人意愿交易等）要求我行退货或承担其他责任，除非法律法规、监管规定另有要求，或我行存在过错。如您取消绑定或终止本协议，或信用卡销户、信用卡过期不办新卡、信用卡挂失不办新卡等，您同意我行将对应的信息（包括原绑卡协议号、卡号后四位等，具体以清算机构规则规定为准）通过合法清算机构传递给合作方平台。</strong
        >
      </p>
      <p>
        <strong class="under-line">
          在您开通、使用本服务过程中，为确保交易安全、核实您的身份等原因，通过本协议约定处理您的个人敏感信息具有必要性。您接受本协议即视为您同意按照本协议项下授权内容处理您的个人信息及相关材料，您将自行承担相应责任及风险（包括本协议列明主体的实际运营方可与我行交互您的个人信息等）。您同意并授权：为持续提供本服务或风险管理、解决争议等目的，无论是否核验成功，我行将在满足律法规、监管规定要求以及应对可能的争议解决所必需的时间及必要范围内收集、留存（保存）、使用您的操作记录及有关信息。您承诺并保证您在开通及使用本服务过程中所填写的姓名、信用卡卡号、手机号码、身份证号等信息真实有效，因您提供虚假信息而引起的法律责任由您承担。
        </strong>
      </p>
      <p>
        <strong class="under-line">
          您同意并授权，在特定场景或特殊渠道为开通、使用本服务对您进行身份识别时，根据清算机构绑卡模式规范要求，我行不提供短信验证码方式验证。
        </strong>
      </p>
      <p>
        5、您应妥善保管该信用卡开户户名、开户类型、与之相关的证件类型及证件号码、手机号码、固定电话、通信地址等与该信用卡有关的一切信息（以下简称“身份信息及卡信息”）。如您的信息发生变更或遗失信用卡、泄露身份信息及或卡信息，您应及时通知我行，以减少可能发生的损失。<strong
          >因您泄露身份信息及或卡信息、密码、数字证书、U盾、丢失信用卡等所致损失需由您自行承担。</strong
        >
      </p>
      <p>
        <strong class="under-line"
          >6、您同意，我行可根据业务发展和风险管理的需要，设置或修改信用卡的支付限额。您在使用本服务时需同时受我行和</strong
        ><u>合作方平台</u
        ><strong>设置的支付限额的约束。</strong
        >在任何情况下，支付金额不应超过我行或<u>合作方平台</u>设置的支付限额（以较少者为准，以下简称“支付限额”）。<strong
          >如实际支付金额大于支付限额，您知晓并同意我行将拒绝执行交易指令。您同意，我行与合作方平台有权根据交易安全需要，调整本协议项下的相关交易规则和交易金额的限制规定。前述支付限额同时受限于信用卡额度。</strong
        >
      </p>
      <p>
        7、我行和合作方平台均有权设置与客户风险承受能力相匹配的最大交易限额，包括单笔及单日累计交易限额。我行和合作方平台设置的最大支付限额不一致的，以较低者为准。如实际支付金额大于支付限额，我行有权拒绝执行交易指令。
      </p>
      <p>
        <u
          >8、您如需解除账户绑定，可通过合作方平台平台将解除绑定指令发送至我行进行解除绑定，或通过登录民生银行全民生活APP卡片管理页面自行完成账户绑定的解除。<strong
            >解除绑定，则本协议终止，但法律法规另有规定或本协议另有约定的除外。</strong
          ></u
        >
      </p>
      <p>
        在解绑过程中，您同意并授权我行和合作方平台将解绑信息（包括原绑卡协议号、卡号后四位等，具体以清算机构规则规定为准）通过合法清算机构进行交互。
      </p>
      <p>
        9、本协议与《中国民生银行民生信用卡章程》（以下简称“信用卡章程”）、《中国民生银行信用卡（个人卡）领用合约》（以下简称“领用合约”）相冲突部分，以本协议为准。<strong
          class="under-line"
          >本协议中未尽事宜，依本行信用卡章程、领用合约相关规定办理。</strong
        >
      </p>
      <p>
        <strong class="under-line"
          >10、您不得利用本服务进行套现、虚假交易、洗钱等行为，且有义务配合我行进行相关调查、提供相关证据，一旦您拒绝配合进行相关调查或拒绝提供相关证据或我行合理认为您存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，我行有权采取以下一种、多种或全部措施：（1）暂停或终止提供本服务；（2）单方面提前解除本协议；（3）单方面提前解除领用合约，并要求您立即结清所有欠款。</strong
        >
      </p>
      <p>
        <strong class="under-line">
          11、您同意，我行有权单方面变更、暂停本服务，有权单方面修改、终止本协议，并于执行前通过我行网站、营业网点、对账单、电子邮件、短信、语音电话等一种或多种方式进行公告、通知，公告期为45个自然日。相关公告经网站、营业网点、对账单、电子邮件、短信、语音电话等方式发布、送达即视为您已收到。您在公告期届满后继续使用本服务的，视同接受有关本协议、本服务修改、变更的内容。本协议终止后，合作方平台在协议终止前已接收并发送我行进行处理的交易指令仍有效，您应承担其后果；我行有权基于提供服务、系统维护等原因暂停本服务，并在暂停本服务前提前告知您，但不受前述公告期之限制；如遇国家法律、法规、规章或其他规范性法律文件的调整或监管机构要求致使我行需提前终止、变更本协议、本服务，则我行有权根据国家法律、法规、规章或其他规范性法律文件、监管机构的要求提前终止、变更本协议、本服务，不受前述公告期之限制。
        </strong>
      </p>
      <p>
        <strong class="under-line">
          12、您同意，如我行与合作方平台终止本服务，则本协议自动终止。
        </strong>
      </p>
      <p>
        <strong class="under-line">
          13、本协议自您通过互联网（Internet）点击确认或以其他方式选择接受之日起生效，有效期至您解除相应账户的绑定，但本协议对个人信息授权期限另有约定的，不受本协议有效期限制。
        </strong>
      </p>
      <p>
        14、本协议的生效、履行及解释均适用中国法律。<strong class="under-line"
          >本协议项下争议向我行所在地有管辖权的人民法院起诉。</strong
        >
      </p>
      <p>
        <strong class="under-line"
          >15、如有疑义或其他问题，请及时拨打我行客户服务热线400-66-95568咨询、处理。</strong
        >
      </p>
    </section>

    <section class="bank-cell china-quick">
      <p class="sub-title">中国民生银行借记卡快捷支付业务用户协议</p>
      <p><strong>重要提示：</strong></p>
      <p>
        <strong
          >尊敬的客户，为维护您的合法权益，请在签署前，仔细阅读本协议全文，关注您在本协议项下的全部权利、义务与责任，并特别注意字体加粗标记的条款(包括但不限于涉及费用、期限、身份识别方式、交易验证方式、交易规则、双方权利义务、个人信息保护等内容的条款)。如您对本协议有任何疑问，请及时通过拨打民生银行客户服务热线(95568)等渠道向民生银行咨询，请您在充分理解本协议、以及自愿接受民生银行按照本协议提供的服务的基础上签署本协议。如您不同意本协议的任何内容，或不能准确理解本协议的任何条款，请不要进行签署和/或其它任何的后续操作。</strong
        >
      </p>
      <p>甲方：个人客户 (下称“客户”)</p>
      <p>乙方：中国民生银行股份有限公司(下称“<strong>民生银行</strong>”)</p>
      <p>
        民生银行与签约本协议的客户，就民生银行为客户使用商盟商务服务有限公司(下称“非银行支付机构”)(联系方式请见非银行支付机构官方网站公布)的借记卡快捷支付业务提供支付服务达成的协议如下：
      </p>
      <p><strong>一、定义</strong></p>
      <p>
        1、借记卡快捷支付业务：指民生银行与非银行支付机构合作向客户提供的支付方式。客户作为民生银行借记卡持有人，可通过非银行支付机构进行付款，付款时无需登录民生银行网上银行，凭客户在非银行支付机构的支付密码、留存的手机号码的动态口令等非银行支付机构届时提供的验证方式，即可完成付款。
      </p>
      <p>
        2、客户：指在非银行支付机构设立支付账户，通过与非银行支付机构签署《快捷支付服务协议》，与民生银行签署本协议开通借记卡快捷支付业务，使用在民生银行开立的结算账户作为借记卡快捷支付业务指定银行账户，并使用借记卡快捷支付业务的个人。
      </p>
      <p>
        3、支付账户：支付账户是指非银行支付机构根据客户申请，为客户开立的具有记录客户资金交易和资金余额功能的电子账簿。
      </p>
      <p>
        4、指定银行账户：指客户开立在民生银行，指定用于绑定支付账户，并使用该账户完成借记卡快捷支付业务的个人银行结算账户。
      </p>
      <p>
        <strong
          >5、手机号码：是指客户在民生银行开立账户时预留信息中的手机号码、客户通过民生银行认可的渠道进行变更后的手机号码预留信息或客户在民生银行认可的第三方机构(如电信运营商等)办理的本人手机号码。</strong
        >
      </p>
      <p>
        6、非银行支付机构支付平台：指非银行支付机构所有并负责维护的用于完成互联网、移动互联网支付业务的系统，与民生银行系统相连以完成借记卡快捷支付业务。
      </p>
      <p><strong>二、双方履行本协议的先决条件</strong></p>
      <p>1、客户是具有完全民事行为能力的自然人。</p>
      <p>
        2、使用借记卡快捷支付业务进行支付时，民生银行完成支付(即，民生银行根据非银行支付机构发送的客户付款指令，自指定银行账户付至付款指令中指定的账户)的前提条件是指定银行账户有充足的活期余额且账户状态正常。
      </p>
      <p>
        3、客户知悉并确认，客户提供的本人银行卡账号、开户户名、开户证件号码、在民生银行预留的手机号等验证信息准确完整。
      </p>
      <p><strong>三、借记卡快捷支付业务安排</strong></p>
      <p>1、交易验证方式与扣款适用范围</p>
      <p>
        为了提升服务体验与服务效率，民生银行与非银行支付机构合作，为客户提供不同的签约绑定服务方式。在民生银行与非银行支付机构已合作提供相应服务的情形下，客户可以自主选择：
      </p>
      <p>
        <strong
          >(a)
          客户本人在非银行支付机构或者民生银行端发起申请，提供其个人相关信息，包括姓名、银行卡号、手机号码、身份证件号码等验证要素，并授权非银行支付机构与民生银行相互提供前述相关信息进行交叉验证，验证通过后，民生银行将客户在非银行支付机构设立的支付账号与客户指定银行账户绑定。</strong
        >
      </p>
      <p>
        <strong
          >(b)
          客户在非银行支付机构端发起申请，授权非银行支付机构将客户本人身份信息，包括姓名、手机号码、身份证件号码等要素发送至民生银行进行验证，并在民生银行的服务页面查看客户本人名下可用于开通快捷支付服务的民生借记卡列表，进行选择与确认。客户同意民生银行将客户通过前述服务页面选择并确认的银行卡账户与客户在非银行支付机构设立的支付账号绑定，并授权民生银行将客户选择并确认的银行卡号、银行预留手机号等信息发送给非银行支付机构。</strong
        >
      </p>
      <p>
        <strong
          >(c)
          客户在民生银行渠道操作，授权民生银行将客户选择并确认的银行卡信息以及个人相关信息，包括姓名、银行卡号、手机号码、身份证件号码等要素发送至非银行支付机构进行查询与核验。非银行支付机构核验通过后，将客户本人在非银行支付机构的支付账户信息发送给民生银行，客户同意在民生银行的渠道服务页面查看前述支付账户列表并进行选择。客户同意民生银行将客户选择并确认的支付账户与客户指定银行账户绑定，并授权民生银行将前述支付账户发送非银行支付机构。</strong
        >
      </p>
      <p>
        <strong
          >客户知悉并授权同意，民生银行与非银行支付机构交互的前述个人信息，包括姓名、银行卡号、手机号码、身份证件号码等验证要素，按照国家相关监管规定需通过网联等清算机构进行转送。在重新取得客户同意的前提下，民生银行可变更验证流程、要素和验证标准。</strong
        >
      </p>
      <p>
        <strong
          >绑定完成后，即视为客户授权民生银行按照非银行支付机构向民生银行发送的支付指令完成支付。</strong
        >
      </p>
      <p>
        快捷支付签约和使用的渠道包括但不限于：计算机、移动电话、移动设备、电视、电话、自助终端等设备，具体以民生银行及非银行支付机构提供的快捷支付渠道为准。
      </p>
      <p>2、交易限额</p>
      <p>
        <strong
          >民生银行和非银行支付机构均有权设置与客户风险承受能力相匹配的最大交易限额，包括单笔及单日累计交易限额，客户可通过民生银行及/或非银行支付机构网站、个人网银、手机银行等渠道查询相关单笔及单日累计交易限额。民生银行和非银行支付机构设置的最大支付限额不一致的，以较低者为准。如实际支付金额大于支付限额，民生银行将有权拒绝执行交易指令。</strong
        >
      </p>
      <p><strong>四、客户权利义务</strong></p>
      <p>
        1、客户同意民生银行根据客户通过非银行支付机构支付平台代理向民生银行发送的对付款指令中指定的银行账户的付款指令及时完成支付。
      </p>
      <p>
        <strong
          >2、客户同意，签署本协议并完成支付账户与指定银行账户的绑定后，非银行支付机构发送至民生银行的支付指令均视为客户发出。客户理解并同意，民生银行根据指令完成支付后，对于交易中可能发生的未在交易单据中签名、签名不符、非本人意愿交易、未验证银行卡/账户支付密码、未验证银行卡/账户U宝或其他安全工具等情况，不会要求民生银行退款或承担其他责任。</strong
        >
      </p>
      <p>
        <strong
          >3、支付账户与指定银行账户绑定成功后，客户在非银行支付机构网站、客户端或其它使用界面输入支付账户密码及(或)按非银行支付机构的业务流程发出符合非银行支付机构要求或约定的指令，即视为客户确认支付金额及该支付指令，并授权非银行支付机构向民生银行发送该交易指令。客户同意并授权民生银行按照非银行支付机构的交易指令从指定银行账户中支付相应款项。
        </strong>
      </p>
      <p>
        <strong
          >4、客户须妥善保管支付账户、指定银行账户信息及其密码及其他信息。</strong
        >
      </p>
      <p>
        客户应当设置不同于签约银行卡交易密码的网络支付密码，妥善保管银行卡开户户名、开户类型、与之相关的证件类型及证件号码、手机号码、固定电话、通信地址等相关信息，如遗失银行卡或泄露上述相关信息，客户应及时通知民生银行并办理挂失或销户等相关手续，避免或减少可能发生的损失。<strong
          >挂失或销户前的已经产生的损失，以及因客户泄露银行卡密码、支付机构账号密码、支付机构支付密码和手机动态密码、数字证书、U宝、丢失银行卡等所致损失，由客户自行承担，民生银行在法律法规允许的范围内不承担责任。</strong
        >
      </p>
      <p>5、银行端快捷支付限额管理</p>
      <p>
        为进一步保障客户的用卡权益，民生银行通过手机银行、网上银行等民生银行认可的渠道(如适用)向客户提供签约快捷支付机构或商户的查询及相应项下具体支付限额自助调整服务，客户可登录民生银行相关服务渠道在民生银行设置的最大支付限额内，修改银行端的单笔限额及每日限额。
      </p>
      <p>
        6、如需解除账户绑定，客户可通过非银行支付机构平台将解约指令发送至民生银行进行解除绑定，或通过登录民生银行已开通解除快捷支付绑定服务的渠道，完成账户绑定的解除。
      </p>
      <p>
        7、如客户签约开通民生银行账户信息通知功能的，如民生银行“即时通”服务等，民生银行将按照客户签约开通的该等功能提供快捷支付交易通知服务。
      </p>
      <p>8、反洗钱</p>
      <p>
        客户与民生银行建立业务关系时，客户应按照反洗钱、反恐怖融资相关法律法规要求，切实履行反洗钱、反恐怖融资义务，确保提供的身份信息、资料真实、完整、合法、有效，并承诺不通过民生银行所提供的金融账户/产品/业务/服务进行洗钱、恐怖融资或其它违法活动。客户与民生银行业务关系存续期间，客户身份信息或资料发生变更时，应主动、及时通知民生银行按业务流程办理更新；民生银行通过风险监测发现可疑交易涉嫌洗钱、恐怖融资或其他违法活动时，有权对客户金融账户/产品/业务/服务采取相应的管控措施，包括但不限于：对交易方式、交易规模、交易频率等实施合理限制、拒绝提供金融服务等。
      </p>
      <p>
        客户不得利用借记卡快捷支付业务进行套现、虚假交易、洗钱等行为，且有义务配合民生银行进行相关调查，一旦客户拒绝配合进行相关调查或民生银行认为客户存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、或违反本协议约定的，民生银行有权采取(包括但不限于)以下一种、多种或全部措施：(1)暂停或终止提供本协议项下借记卡快捷支付业务服务；(2)终止本协议。因客户的前述行为给民生银行造成损失的，客户对民生银行承担赔偿责任。
      </p>
      <p><strong>五、民生银行权利义务</strong></p>
      <p>
        1、民生银行有权将签署本协议并完成支付账户与指定银行账户的绑定后，非银行支付机构发送至民生银行的支付指令视为客户发出，无需验证客户的借记卡、数字证书(如适用)和密码等信息即可执行支付指令，<strong
          >执行后无法撤销。</strong
        >
      </p>
      <p>
        2、民生银行有权对民生银行系统进行维护升级，并应对维护升级提前合理时间予以公告。
      </p>
      <p>
        3、民生银行有权根据业务发展需要修改最大支付限额，以及确定指定银行账户可以绑定的支付账户数量，客户可以通过手机银行和网上银行的协议管理项目进行查询。
      </p>
      <p>
        4、民生银行仅通过借记卡快捷支付业务提供支付服务。客户因通过非银行支付机构完成的交易而产生的一切关于产品质量、服务质量及费用扣收等争议均由客户与实际提供产品或服务的商户自行解决，与民生银行无关。
      </p>
      <p><strong>六、个人信息授权及保护</strong></p>
      <p>
        <strong
          >1、本协议履行期间，为订立、履行本协议之目的，客户自愿授权民生银行依据有关法律法规或其他规范性文件的规定或金融监管机构的要求，通过合法渠道和手段收集、存储、使用、加工、传输本协议约定的客户个人信息。</strong
        >
      </p>
      <p>
        <strong
          >2、民生银行应当依照相关法律法规的规定妥善保存完整的支付信息，客户可通过手机银行和个人网银查询相关第三方支付机构的签约信息，并可通过手机银行、个人网银及银行柜台等渠道查询交易记录。</strong
        >
      </p>
      <p>
        <strong
          >3、客户知悉并同意，民生银行可据存证管理需要将客户签署的任何电子文本、线上操作系统记录的哈希摘要存储于民生银行区块链电子存证平台，并作为有效电子证据。客户同意，为处理纠纷之目的，民生银行可选择区块链电子存证平台节点公证机构对客户签署电子文本及操作记录、痕迹等按公证机构流程进行公证，客户授权民生银行将为办理公证将文本内容、客户电子操作系统记录及痕迹、为办理公证所必需的客户个人及企业信息提供给公证机构。如遇法律纠纷，民生银行将在严格遵守法律法规的前提下，为解决纠纷目的，向公证机构、相关司法机构或仲裁机构提供前述信息。</strong
        >
      </p>
      <p>
        <strong
          >4、在本协议履行过程中，双方获知的任何一方的商业秘密，未经秘密所有方的同意，不得以任何形式向任何第三方透露；否则，应向秘密所有方承担相应的法律责任。民生银行应保守在履行本协议中获取的客户个人信息和隐私，但获得授权、或法律、法规(及其不时修订)另有规定或国家有关机关要求提供或披露的除外。</strong
        >
      </p>
      <p>
        <strong
          >5、民生银行将按照法律法规和相关监管规定的要求对因履行本协议而获得的客户个人信息予以保存和使用。出于履行法定义务或配合国家有权部门履行其法定职责，以及其他根据法律、行政法规等规定需配合提供的情况下，民生银行可依法向前述司法机关、国家有权部门等相关机构提供客户相关个人信息。</strong
        >
      </p>
      <p><strong>七、不可抗力与银行责任的免除与限制</strong></p>
      <p>
        <strong
          >1、客户使用民生银行服务时，如非民生银行过错而发生的数据电文错误或者对客户指令识别、处理或执行错误时，民生银行对因该项错误的发生所导致的损失和其他不利后果不承担责任；但民生银行可在客户处理时对客户提供必要的协助。</strong
        >
      </p>
      <p>
        2、由于不可预测或无法控制的通讯/电力/故障/系统故障、或国家法律法规的限制、或遇有其他不可抗力(包括但不限于战争、自然灾害、火灾、疫情等)或无法控制的其他情况，导致本协议无法正常履行的，民生银行依法对前述情形引发的客户损失不承担或承担部分责任。但因民生银行过错引起的系统故障、设备故障、通讯故障、电力故障造成客户损失的，不免除民生银行责任。
      </p>
      <p>
        <strong
          >3、若发生民生银行对于合法有效的客户指令识别错误或执行错误，则客户须在知道或应当知道错误发生后于两个工作日内书面通知民生银行并尽力采取措施防止损失扩大，民生银行应尽快调查处理并在合理可行的范围内采取补救措施，对于因银行/银行账户系统错误而造成的客户直接财产损失，民生银行应按适用的规则予以赔偿，但对于任何间接损失、履行利益、后果性损害、非财产损害、民生银行于错误发生时不可预见的损失以及因客户未能及时通知或及时采取措施而导致扩大的损失，民生银行不承担责任。</strong
        >
      </p>
      <p>八、其他</p>
      <p>
        <strong
          >1、本协议的签署及履行均适用中华人民共和国法律，不包括中国香港特别行政区、澳门特别行政区和台湾地区法律。本协议生效后施行的法律法规和监管规章的有关规定与本协议内容冲突的，以有关法律法规和监管规章规定为准。本协议履行过程中发生问题和纠纷时，应由协议双方本着友好、平等、互利的态度协商解决。客户与民生银行有关本协议的一切争议，经各方协商一致，选择如下争议解决方式：</strong
        >
      </p>
      <p>由中国民生银行股份有限公司住所地有管辖权的法院管辖。</p>
      <p>
        上述争议有关的相关通知、争议文件送达地址为：北京市西城区复兴门内大街2号。
      </p>
      <p>
        2、民生银行进行电子银行系统升级、业务规则变化、服务变更或修改本协议时，将通过民生银行网站(网址：http://www.cmbc.com.cn/)、网上银行或手机银行等渠道提前5个工作日公告，其中，提高服务费率或新增服务收费项目应至少于施行前3个月进行公示，请客户及时关注、及时认真阅读相关通知、公告、修订版协议。以上相关信息自发布之日即视为已送达客户。
      </p>
      <p>
        <strong
          >3、若客户不同意上述有关变更，其有权以书面或其他民生银行许可方式通知民生银行终止本协议。公告到期后客户继续办理快捷支付业务的，视同接受有关本协议、快捷支付业务服务的修改内容。
        </strong>
      </p>
      <p>
        <strong
          >4、因法律法规变化、监管要求需要修订或终止本协议的，民生银行有权根据法律法规变化及监管要求对协议进行变更或终止，民生银行在通过第八条第二款约定的公告方式通知客户后，据此变更或解除本协议。客户应及时认真阅读相关通知、公告或修订版协议，并可通过民生银行在线客服或官方热线95568进行咨询，以便民生银行就前述内容为客户进行解释和说明。</strong
        >
      </p>
      <p><strong>5、客户确认本人已阅读、理解并接受本协议所有内容。</strong></p>
      <p>
        <strong
          >6、本协议以如下方式签署：线上签约方式。电子合同经签约双方电子签名后，发生法律效力。客户通过民生银行或非银行支付机构提供的电子渠道对本协议进行的任何形式的签名确认，包括但不限于使用密码（包括但不限于登录密码、交易密码、短信验证码等）、数字证书、勾选、点击确认、在银行电子签约设备屏幕手写签名等形式，均为客户真实意思的表达，表示客户自愿签署并同意本协议。双方均承认双方通过本协议约定签约方式完成协议签署的法律效力。</strong
        >
      </p>
      <p>
        <strong
          >7、借记卡快捷支付业务自民生银行经客户通过民生银行及/或非银行支付机构页面如实填写相关信息，并由民生银行完成验证，支付账户与指定银行账户完成绑定后生效。</strong
        >
      </p>
      <p>
        <strong>8、如客户有投诉或建议，可拨打民生银行服务热线95568。 </strong>
      </p>
      <p>
        9、本协议生效后施行的法律法规和监管规章的有关规定与本协议内容冲突的，以届时有关法律法规和监管规章规定为准。
      </p>
    </section>

    <section class="bank-cell china-quick">
      <p class="sub-title">交通银行借记卡快捷支付服务协议</p>
      <p>重要提示</p>
      <p>
        尊敬的客户，您在对应业务渠道相应页面按提示说明文字完成相应操作后，页面显示成功信息前，请您仔细阅读本协议的全部内容（尤其是带有▲▲标记的条款）。如您对本协议有任何疑问、意见建议或需进行投诉，请及时至交通银行营业网点或拨打交通银行客户服务热线95559咨询。如您不同意本协议的任何内容，或者无法准确理解相关条款的含义，请不要进行后续操作。您在对应业务渠道相应页面阅读并同意本协议、按提示说明文字完成相应操作后，页面显示成功信息，即表示您对本协议所有内容无疑问和异议，完全理解并同意接受本协议的全部约定内容（尤其是带有▲▲标记的条款），确认承担由此产生的一切责任。
      </p>
      <p>
        鉴于交通银行太平洋借记卡持卡人（以下简称“甲方”）拟向该借记卡开户网点所属交通银行股份有限公司分行（以下简称“乙方”）申请开通交通银行借记卡【"统统付”】快捷支付服务，为明确甲乙双方权利义务，特订立本协议。
      </p>
      <p><strong>一、服务内容和流程</strong></p>
      <p>
        （一）“快捷支付服务”是指，甲方向乙方申请将甲方指定太平洋借记卡与甲方在【商盟商务服务有限公司】（以下简称“支付机构”）开立的支付账户绑定，绑定后，甲方通过支付账户进行支付（包括但不限于通过支付账户向甲方购买商品/服务的卖方付款、向支付账户充值等，下同）且选择使用指定太平洋借记卡内资金的，支付机构将向乙方发送指令。乙方按本协议约定，根据支付机构指令扣划甲方指定太平洋借记卡内资金用于支付。
      </p>
      <p>
        （二）甲方可在支付机构渠道，或通过交通银行手机银行、微银行等渠道（以下简称“电子渠道”）跳转至支付机构渠道后申请开通快捷支付服务。甲方需在支付机构渠道相关页面填写或选定姓名、借记卡卡号、手机号码、身份证件号码信息，支付机构验证甲方身份后，将甲方填写或选定的上述信息发送给乙方。乙方收到支付机构发送的上述信息后，将上述信息与甲方在乙方预留的客户信息进行比对验证，并通过短信验证码等方式验证甲方身份。前述验证均通过后，乙方将甲方指定太平洋借记卡与支付机构支付账户绑定，快捷支付服务开通成功。
      </p>
      <p>
        （三）快捷支付服务开通成功，即视为甲方同意并授权乙方按照支付机构指令从甲方指定太平洋借记卡内主动划扣资金进行支付。后续甲方在支付机构提供的渠道上使用快捷支付服务的，乙方按支付机构指令从甲方指定太平洋借记卡内划扣资金进行支付时，甲方只需根据支付机构要求完成相关验证，乙方不再进行验证。甲方使用快捷支付服务时的支付账户密码设置、修改以及具体支付交易过程中的验证方式等具体规则，以甲方与支付机构签署的快捷支付相关协议约定为准。
      </p>
      <p><strong>二、甲方的权利和义务</strong></p>
      <p>
        （一）甲方应确保用于开通快捷支付服务的太平洋借记卡为本人所有，保证在服务开通过程中提供的信息真实、准确、有效，确保支付行为合法并未侵犯任何第三方合法权益，否则因此造成乙方或其他第三方损失的，由甲方负责赔偿并承担法律责任，因乙方过错依法应由乙方承担的责任除外。
      </p>
      <p>
        ▲▲（二）甲方应妥善保管本人交通银行太平洋借记卡卡号及密码、与之相关的证件类型和证件号码、手机号码、通讯地址、动态密码、支付机构支付账户登录名以及甲方与支付机构约定的其他各类密码、动态验证码、数字证书、指纹及人脸要素等信息，不得将该等信息向他人透露。因甲方原因导致该等信息泄露而产生的风险及损失由甲方本人承担，因乙方过错依法应由乙方承担的责任除外。
      </p>
      <p>
        ▲▲（三）甲方不得利用快捷支付服务进行套现、虚假交易、洗钱、恐怖融资、逃税等行为，且有义务配合乙方进行相关调查。甲方不涉及联合国及相关国家、组织、机构发布的制裁名单，及中国政府部门或有权机关发布的涉恐及反洗钱相关风险名单内的企业或个人；不位于被联合国及相关国家、组织、机构制裁的国家和地区。
      </p>
      <p>
        如若甲方拒绝配合进行相关调查或乙方认为甲方存在或涉嫌套现、虚假交易、洗钱、恐怖融资、逃税或任何其他非法活动、欺诈或违反诚信原则的行为、涉及上述制裁及反洗钱相关风险名单、位于上述被制裁的国家和地区、或违反本协议约定的，乙方有权采取以下一种、多种或全部措施：
      </p>
      <p>（1）暂停或终止提供本协议项下快捷支付服务；</p>
      <p>（2）终止本协议；</p>
      <p>（3）取消甲方的用卡资格。</p>
      <p>若因甲方的前述行为而给乙方造成损失的，甲方还应承担相应的赔偿责任。</p>
      <p><strong>▲▲三、乙方的权利和义务</strong></p>
      <p>
        （一）乙方仅根据本协议约定，按照支付机构指令扣划资金进行支付。甲方使用快捷支付服务的，因购买商品或服务而产生的关于商品或服务质量、商品交付、交易款项及费用扣收与划付的一切争议均由甲方与商品/服务的实际销售商以及支付机构自行协商解决，乙方不承担责任，因乙方过错依法应由乙方承担的责任除外。
      </p>
      <p>
        （二）乙方有权根据交易安全需要和客户体验设置（包括修改，下同）甲方指定太平洋借记卡在相应支付机构的快捷支付交易限额，甲方无法对此进行修改，具体交易限额以支付机构渠道相关页面展示为准。甲方快捷支付金额不应超过乙方设置的快捷支付交易限额和支付机构设置的支付限额（以较低者为准），如实际支付金额大于前述限额的，乙方将拒绝执行。甲方在本协议下指定的太平洋借记卡为Ⅱ类、Ⅲ类账户的，支付限额除受乙方设置的快捷支付交易限额和支付机构设置的支付限额限制外，还受相应Ⅱ类、Ⅲ类账户自身限额限制。
      </p>
      <p>
        （三）快捷支付服务开通后，对于乙方正确执行支付机构指令产生的资金扣划，如甲方对相应资金支付存有异议，甲方应与支付机构自行解决，乙方对此不承担责任，因乙方过错依法应由乙方承担的责任除外。
      </p>
      <p>
        （四）甲方通过乙方电子渠道跳转至支付机构渠道后申请开通快捷支付服务的，为了开通快捷支付服务所必需，甲方同意乙方将甲方姓名、借记卡卡号、手机号码、身份证件号码信息发送至支付机构（支付机构联系方式请见支付机构官方网站）。
      </p>
      <p>
        <strong>
          ▲▲四、法律适用与争议解决
        </strong>
      </p>
      <p>
        本协议适用中华人民共和国法律（为本协议目的不包括香港、澳门和台湾地区的法律）。本协议项下争议应向乙方所在地有管辖权的人民法院起诉，双方另有约定的除外。争议期间，各方仍应继续履行未涉争议的条款。
      </p>
    </section>
    <p>
      <strong>
        ▲▲五、信息披露与保密
      </strong>
    </p>
    <p>
      对于在本协议签订和履行过程中获取和知悉的甲方的未公开信息和资料，乙方对相关信息和资料的处理（包括但不限于收集、存储、使用、加工、传输、提供、公开等）不得违反法律法规和监管要求，并应依法承担保密责任，不向第三方披露该等信息和资料，但下列情形除外：
    </p>
    <p>（1）适用法律法规要求披露的；</p>
    <p>（2）司法部门或监管机构依法要求披露的；</p>
    <p>
      （3）乙方为行使本协议项下权利、履行本协议项下义务需向乙方的外部专业顾问披露和允许乙方的外部专业顾问在保密的基础上使用的；
    </p>
    <p>（4）为维护公共利益或者甲方合法权益,合理实施其他行为的；</p>
    <p>（5）甲方另行同意或授权乙方进行披露的。</p>
    <p><strong>▲▲第六条 通知</strong></p>
    <p>
      甲方保证其向乙方提供的的联系方式（包括通讯地址、联系电话、传真号码、电子邮件等）均真实有效。任一联系方式发生变更，甲方应立即以书面方式将变更信息寄/送至乙方。该等信息变更在乙方收到更改通知后生效。
    </p>
    <p>
      6.2除本协议另有明确约定外，乙方对甲方的任何通知，乙方有权通过以下任一方式进行。乙方有权选择其认为合适的通知方式，且无需对邮递、传真、电话、电传、微信或任何其他通讯系统所出现的传送失误、缺漏或延迟承担责任。乙方同时选择多种通知方式的，以其中较快到达甲方者为准。就同一事项，乙方对甲方发出一份以上通知且通知内容不同的，除非在通知中另有明确说明，以通知发出时间在后的为准。
    </p>
    <p>
      （1）公告，以乙方在其网站、网上银行、电话银行或营业网点发布公告之日视为送达日；
    </p>
    <p>（2）专人送达，以甲方签收之日视为送达日；</p>
    <p>
      （3）邮递（包括特快专递、平信邮寄、挂号邮寄）送达于乙方最近所知的甲方通讯地址，以邮寄之日后的第3日（同城）/第5日（异地）视为送达日；
    </p>
    <p>
      （4）传真、移动电话短信或其他电子通讯方式送达于乙方最近所知的甲方传真号码、甲方指定的移动电话号码或电子邮件地址，以发送之日视为送达日，前述送达指相关信息进入服务商的服务器终端而不以相关信息实际在客户终端显示为标准。
    </p>
    <p>
      甲方同意，除非乙方收到甲方关于变更通讯地址的书面通知，甲方在本协议填写的通讯地址是法院向甲方送达司法文书及其他书面文件的地址。上述送达地址适用的范围包括但不限于民事诉讼一审、管辖权异议及复议、二审、再审、发回重审和执行程序等。如甲方应诉并直接向法院提交送达地址确认书，该确认地址与乙方最近所知的通讯地址不一致的，法院有权以送达地址确认书上的地址为准进行送达。
    </p>
    <p>
      本协议争议解决过程中，法院可通过以下任一方式将判决书、裁定书、调解书送达于甲方：
    </p>
    <p>
      （1）邮递送达（包括特快专递、平信邮寄、挂号邮寄），以甲方在送达回证上的签收日为送达之日；
    </p>
    <p>（2）专人送达，以甲方在送达回证上的签收之日视为送达之日。</p>
    <p>
      法院采用邮寄送达（包括特快专递、平信邮寄、挂号邮寄）方式的，如甲方未在送达回证上签收或甲方所填写的通讯地址不准确或通讯地址实际发生变更但乙方未收到甲方关于变更通讯地址的书面通知导致判决书、裁定书、调解书被退回的，以文书被退回之日视为送达之日。
    </p>
    <p>
      法院采用专人送达方式的，如甲方未在送达回证上签收，以送达人当场在送达回证上记明情况之日为送达之日。
    </p>
    <p>
      除判决书、裁定书、调解书外，法院对甲方的任何通知，法院有权通过第6.2条约定的任一通讯方式进行。法院有权选择其认为合适的通讯方式，且无需对邮递、传真、电话、电传、微信或任何其他通讯系统所出现的传送失误、缺漏或延迟承担责任。法院同时选择多种通讯方式的，以其中较快到达甲方者为准。
    </p>
    <p>
      本条约定属于协议中独立存在的解决争议条款，本协议无效、被撤销或者终止的，不影响本条款的效力。
    </p>
    <p><strong>七、协议的生效、变更与终止</strong></p>
    <p>
      （一）本协议自签署后生效，签署是指甲方在对应业务渠道相应页面按提示说明文字完成相应操作后，页面显示成功信息。
    </p>
    <p>
      ▲▲（二）甲方同意，在不违反适用的法律、法规、规章和监管规定的强制性规范的前提下，乙方有权变更、暂停本协议项下快捷支付服务以及修改协议，并于相应变更、暂停、修改执行前通过乙方电子渠道或营业网点公告，或通过电话、短信等方式通知甲方。甲方不同意相应变更、暂停或修改的，有权在公告执行前或在电话、短信载明的时间前解除快捷支付协议。甲方在公告执行后或在电话、短信载明的时间后继续办理快捷支付服务的，视同接受相应变更、暂停、修改。
    </p>
    <p>
      甲方同时同意，乙方有权终止本协议项下快捷支付服务并有权终止本协议，在不违反适用的法律、法规、规章和监管规定的强制性规范的前提下，乙方有权提前通过乙方线上渠道或营业网点公告，本协议自公告中载明的终止时间终止。
    </p>
    <p>
      ▲▲（三）甲方可通过支付机构渠道或乙方电子渠道跳转至支付机构渠道后主动解除甲方指定太平洋借记卡与支付账户的绑定关系，具体解除渠道以支付机构和乙方电子渠道相关页面展示为准。支付机构解除甲方与支付机构签署的快捷支付相关协议的，甲方指定太平洋借记卡与支付账户的绑定关系亦相应解除。
    </p>
    <p>
      乙方收到甲方及或/支付机构关于甲方指定太平洋借记卡与支付账户绑定关系解除的通知后，本协议自动解除。本协议解除后，乙方不再受理和执行支付机构指令。本协议解除前乙方收到的支付机构指令，乙方仍将按前述指令执行，甲方应承担由此产生的全部后果和责任，该等指令全部执行完毕后本协议终止。
    </p>
    <p>
      ▲▲（四）如因甲方指定太平洋借记卡注销、补（换）卡等任何原因导致卡号变更的，甲方指定太平洋借记卡与支付账户的绑定关系相应解除。乙方为甲方办妥相应注销、补（换）卡手续后，本协议自动解除。本协议解除后，乙方不再受理和执行支付机构指令。本协议解除前乙方收到的支付机构指令，乙方仍将按前述指令执行，甲方应承担由此产生的全部后果和责任，该等指令全部执行完毕后本协议终止。
    </p>
    <p>
      甲方如需再次使用快捷支付服务的，须重新阅读并签署本协议、重新申请开通快捷支付服务。甲方指定太平洋借记卡进行补（换）卡等操作但卡号不变的，无需办理前述手续。
    </p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.bank-agreement-container {
  padding: 15px;
  font-size: 14px;
  line-height: 24px;
  .title {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 50px;
  }
  > p:nth-child(n + 2) {
    text-indent: 2em;
  }
  .under-line {
    text-decoration: underline;
  }
  .common-cnt {
    .sub-title {
      margin: 20px 0;
      font-size: 14px;
      text-align: center;
      font-weight: bold;
      line-height: 40px;
    }
    > p:nth-child(n + 4) {
      text-indent: 2em;
    }
  }
  .footer-tips {
    margin-top: 50px;
  }
  .bank-cell {
    .sub-title {
      margin: 10px 0;
      font-size: 12px !important;
      text-align: center;
      font-weight: bold;
      line-height: 40px;
    }
  }
  .china-quick {
    p:nth-child(n + 2) {
      text-indent: 2em;
    }
  }
}
</style>
